{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021 - 2025                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCDataBinding;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

{$IFNDEF LCLWEBLIB}
{$HINTS OFF}
{$IF COMPILERVERSION > 33}
{$DEFINE SUPPORTSBINDING}
{$IFEND}
{$HINTS ON}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCPersistence, WEBLib.TMSFNCTypes, WEBLib.TMSFNCCustomComponent,
  WEBLib.Controls, TypInfo
  {$IFNDEF LCLLIB}
  , Generics.Collections
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fgl
  {$ENDIF}
  {$IFDEF LCLWEBLIB}
  ,DB
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  ,Data.DB
  {$ENDIF}
  {$IFDEF SUPPORTSBINDING}
  ,Data.Bind.Components, Data.Bind.ObserverLinks
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 2; // Build nr.

  // version history
  // v1.0.0.0 : First Release
  // v1.0.0.1 : Fixed : Issue with incorrect Owner being passed to runtime editor
  // v1.0.0.2 : Fixed : Issue with vcl styles in design-time editor
  //          : Fixed : Issue in vcl selecting field & property name

type
  ITMSFNCDataBinderBase = interface
    ['{778B63C9-34E3-4B65-A6B8-85E3EB1D17C3}']
    procedure DataBeginUpdate;
    procedure DataEndUpdate;
  end;

  ITMSFNCDataBinderGrid = interface(ITMSFNCDataBinderBase)
    ['{D23BDEAA-49B1-451A-9401-0D0D11A9957A}']
    procedure SetDataColumnCount(AValue: Integer);
    procedure SetDataRowCount(AValue: Integer);
    procedure ClearData;
    function GetDataRowCount: Integer;
    procedure SetDataValue(AColumn, ARow: Integer; AValue: string);
    procedure SetDataHeader(AColumn: Integer; AValue: string);
    procedure DataInsertRow(AInsertPosition: Integer);
  end;

  ITMSFNCDataBinderSelection = interface
    ['{F7D3F4D2-F202-48C0-9036-3F03E642F1E5}']
    function DataGetItemIndex: Integer;
    procedure DataSetItemIndex(AValue: Integer);
  end;

  TTMSFNCDataBinderNotificationType = (dbntUpdate, dbntEdit, dbntPost, dbntValueChanged, dbntSetActiveRecord);

  ITMSFNCDataBinderNotification = interface
  ['{3CEED28B-A125-4B26-B765-72785F2B0180}']
    function GetObject: TObject;
    procedure SetObject(const Value: TObject);
    procedure Notify(AType: TTMSFNCDataBinderNotificationType);
    property &Object: TObject read GetObject write SetObject;
  end;

  ITMSFNCDataBinderNotificationManager = interface
    ['{AFAFFAD9-AA33-4063-9BCB-6A17EC97D5C1}']
    procedure Notify(AControl: TObject; AType: TTMSFNCDataBinderNotificationType);
  end;

  ITMSFNCDataBinderNotificationManagerReference = interface
    ['{AFAFFAD9-AA33-4063-9BCB-6A17EC97D5C1}']
    procedure AddManager(AManager: ITMSFNCDataBinderNotificationManager);
    procedure RemoveManager;
  end;

  {$IFDEF WEBLIB}
  TTMSFNCDataBinderNotificationManager = class(TList, ITMSFNCDataBinderNotificationManager)
  {$ELSE}
  TTMSFNCDataBinderNotificationManager = class(TList<ITMSFNCDataBinderNotification>, ITMSFNCDataBinderNotificationManager)
  {$ENDIF}
  private
    FOwnerInterface: IInterface;
  protected
    {$IFDEF LCLLIB}
    function _AddRef : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    function _Release : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    {$ELSE}
    function _AddRef: Integer; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    function _Release: Integer; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    {$ENDIF}
    function HasObject(AObject: TObject): Boolean;
  public
    {$IFDEF LCLLIB}
    function QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} iid : tguid;out obj) : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    {$ELSE}
    function QueryInterface(const IID: TGUID; out Obj): HResult; virtual; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    {$ENDIF}
    procedure Notify(AObject: TObject; AType: TTMSFNCDataBinderNotificationType); reintroduce; virtual;
  end;

  TTMSFNCDataBinder = class;

  TTMSFNCDataBinderItem = class;

  TTMSFNCDataBinderDataLinkMode = (dlmActiveChanged, dlmDataSetChanged, dlmDataSetScrolled, dlmRecordChanged, dlmUpdateData);

  TTMSFNCDataBinderDataLink = class(TDataLink)
  private
    FDataBinderItem: TTMSFNCDataBinderItem;
  protected
    procedure ActiveChanged; override;
    procedure DataSetChanged; override;
    procedure DataSetScrolled(Distance: Integer); override;
    procedure RecordChanged(Field: TField); override;
    procedure UpdateData; override;
  public
    constructor Create(ADataBinderItem: TTMSFNCDataBinderItem);
    destructor Destroy; override;
  end;

  TTMSFNCDataBinderBindType = (dbbtSingleValue, dbbtList, dbbtColumnList, dbbtGrid);

  TTMSFNCDataBinderPropertyName = class(TCollectionItem)
  private
    FDataBinderItem: TTMSFNCDataBinderItem;
    FValue: string;
    procedure SetValue(const Value: string);
  public
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    property DataBinderItem: TTMSFNCDataBinderItem read FDataBinderItem;
  published
    property Value: string read FValue write SetValue;
  end;

  {$IFDEF WEBLIB}
  TTMSFNCDataBinderPropertyNames = class(TTMSFNCOwnedCollection)
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCDataBinderPropertyNames = class({$IFDEF LCLLIB}specialize {$ENDIF}TTMSFNCOwnedCollection<TTMSFNCDataBinderPropertyName>)
  {$ENDIF}
  private
    FOwner: TTMSFNCDataBinderItem;
    function GetItemEx(Index: Integer): TTMSFNCDataBinderPropertyName;
    procedure SetItemEx(Index: Integer; const Value: TTMSFNCDataBinderPropertyName);
  protected
    function GetDataBinderPropertyNameClass: TCollectionItemClass; virtual;
  public
    constructor Create(AOwner: TTMSFNCDataBinderItem);
    function Add: TTMSFNCDataBinderPropertyName;
    function Insert(index: Integer): TTMSFNCDataBinderPropertyName;
    property Items[Index: Integer]: TTMSFNCDataBinderPropertyName read GetItemEx write SetItemEx; default;
  end;

  TTMSFNCDataBinderFieldName = class(TCollectionItem)
  private
    FDataBinderItem: TTMSFNCDataBinderItem;
    FValue: string;
    FHTMLTemplate: string;
    procedure SetValue(const Value: string);
    procedure SetHTMLTemplate(const Value: string);
  public
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    property DataBinderItem: TTMSFNCDataBinderItem read FDataBinderItem;
  published
    property Value: string read FValue write SetValue;
    property HTMLTemplate: string read FHTMLTemplate write SetHTMLTemplate;
  end;

  {$IFDEF WEBLIB}
  TTMSFNCDataBinderFieldNames = class(TTMSFNCOwnedCollection)
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCDataBinderFieldNames = class({$IFDEF LCLLIB}specialize {$ENDIF}TTMSFNCOwnedCollection<TTMSFNCDataBinderFieldName>)
  {$ENDIF}
  private
    FOwner: TTMSFNCDataBinderItem;
    function GetItemEx(Index: Integer): TTMSFNCDataBinderFieldName;
    procedure SetItemEx(Index: Integer; const Value: TTMSFNCDataBinderFieldName);
  protected
    function GetDataBinderFieldNameClass: TCollectionItemClass; virtual;
  public
    constructor Create(AOwner: TTMSFNCDataBinderItem);
    function Add: TTMSFNCDataBinderFieldName;
    function Insert(index: Integer): TTMSFNCDataBinderFieldName;
    property Items[Index: Integer]: TTMSFNCDataBinderFieldName read GetItemEx write SetItemEx; default;
  end;

  TTMSFNCDataBinderFindType = (bftDontCare, bftClass, bftString);

  {$IFDEF SUPPORTSBINDING}
  TTMSFNCDataBinderControlValueObserver = class(TBindMultiCastObserver, IControlValueObserver, IObserverTrack)
  private
    FTrack: Boolean;
    FModified: Boolean;
    FBinderItem: TTMSFNCDataBinderItem;
  protected
    function GetTrack: Boolean;
  public
    constructor Create(ABinderItem: TTMSFNCDataBinderItem) overload;
    destructor Destroy; override;
    procedure SetTrack(AValue: Boolean);
    procedure ValueUpdate;
    procedure ValueModified;
  end;

  TTMSFNCDataBinderEditLinkObserver = class(TBindSingleCastObserver, IEditLinkObserver, IObserverTrack)
  private
    FTrack: Boolean;
    FModified: Boolean;
    FBinderItem: TTMSFNCDataBinderItem;
  protected
    function GetTrack: Boolean;
  public
    constructor Create(ABinderItem: TTMSFNCDataBinderItem) overload;
    destructor Destroy; override;
    procedure BeginUpdate;
    procedure EndUpdate;
    function GetUpdating: Boolean;
    procedure Update;
    function Edit: Boolean;
    procedure Reset;
    procedure Modified;
    function IsModified: Boolean;
    function IsValidChar(AKey: Char): Boolean;
    function IsRequired: Boolean;
    function GetIsReadOnly: Boolean;
    procedure SetIsReadOnly(Value: Boolean);
    function GetIsEditing: Boolean;
    procedure SetTrack(AValue: Boolean);
    function GetFormatLink: IEditFormatLink;
  end;
  {$ENDIF}

  TTMSFNCDataBinderControlValueMonitor = class
  private
    {$IFDEF SUPPORTSBINDING}
    FObserver: TTMSFNCDataBinderControlValueObserver;
    {$ENDIF}
    FActive: Boolean;
    FBinderItem: TTMSFNCDataBinderItem;
  public
    constructor Create(ABinderItem: TTMSFNCDataBinderItem);
    destructor Destroy; override;
    procedure StartMonitoring;
    procedure StopMonitoring;
    property Active: Boolean read FActive;
    {$IFDEF SUPPORTSBINDING}
    property Observer: TTMSFNCDataBinderControlValueObserver read FObserver;
    {$ENDIF}
  end;

  TTMSFNCDataBinderEditLinkMonitor = class
  private
    {$IFDEF SUPPORTSBINDING}
    FObserver: TTMSFNCDataBinderEditLinkObserver;
    {$ENDIF}
    FActive: Boolean;
    FBinderItem: TTMSFNCDataBinderItem;
  public
    constructor Create(ABinderItem: TTMSFNCDataBinderItem);
    destructor Destroy; override;
    procedure StartMonitoring;
    procedure StopMonitoring;
    property Active: Boolean read FActive;
    {$IFDEF SUPPORTSBINDING}
    property Observer: TTMSFNCDataBinderEditLinkObserver read FObserver;
    {$ENDIF}
  end;

  TTMSFNCDataBinderItem = class(TCollectionItem, ITMSFNCDataBinderNotification)
  private
    FControlValueMonitor: TTMSFNCDataBinderControlValueMonitor;
    FEditLinkMonitor: TTMSFNCDataBinderEditLinkMonitor;
    FOwnerInterface: IInterface;
    FDirty: Boolean;
    FUpdating: Boolean;
    FDataBinder: TTMSFNCDataBinder;
    FDataLink: TTMSFNCDataBinderDataLink;
    FActive: Boolean;
    FBindType: TTMSFNCDataBinderBindType;
    FObject: TObject;
    FPropertyName: string;
    FFieldName: string;
    FSubPropertyNames: TTMSFNCDataBinderPropertyNames;
    FSubFieldNames: TTMSFNCDataBinderFieldNames;
    FColumnsPropertyName: string;
    FColumnsSubPropertyName: string;
    FBufferCount: Integer;
    FBooleanStringValue: string;
    FHTMLTemplate: string;
    FName: string;
    function GetField: TField;
    function GetDataSource: TDataSource;
    procedure SetDataSource(const Value: TDataSource);
    procedure SetActive(const Value: Boolean);
    procedure SetBindType(const Value: TTMSFNCDataBinderBindType);
    procedure SetObject(const Value: TObject);
    procedure SetPropertyName(const Value: string);
    procedure SetFieldName(const Value: string);
    procedure SetColumnsPropertyName(const Value: string);
    procedure SetColumnsSubPropertyName(const Value: string);
    procedure SetBufferCount(const Value: Integer);
    function GetBindComponent: TComponent;
    procedure SetBindComponent(const Value: TComponent);
    procedure SetBooleanStringValue(const Value: string);
    procedure SetHTMLTemplate(const Value: string);
    function GetObjectInstance: TObject;
    procedure SetObjectInstance(const Value: TObject);
    function GetObject: TObject;
    function GetControlValueMonitor: TTMSFNCDataBinderControlValueMonitor;
    function GetEditLinkMonitor: TTMSFNCDataBinderEditLinkMonitor;
  protected
    procedure Reset;
    procedure SetIsReadOnly(const AValue: Boolean);
    procedure Modified;
    function GetCanModify: Boolean;
    function IsValidChar(const AChar: Char): Boolean;
    function IsRequired: Boolean;
    function GetComponent: TComponent;

    procedure DestroyMonitors;
    procedure DoChanged(Sender: TObject);
    procedure Notify(AType: TTMSFNCDataBinderNotificationType);
    property BufferCount: Integer read FBufferCount write SetBufferCount default 0;
    property Field: TField read GetField;
    function HasControlValueMonitor: Boolean;
    function HasEditLinkMonitor: Boolean;
    function TryGetObjectStringValue(AObject: TObject; out AValue: string): Boolean;
    function TrySetObjectStringValue(AObject: TObject; const AValue: string): Boolean;
    function HTMLDBReplace(AValue: string; ADataset: TDataSet): string; virtual;
    function GetDisplayName: string; override;
    function InternalFindProperty(AObject: TObject; AName: string; AFindType: TTMSFNCDataBinderFindType = bftDontCare; IncludePublic: Boolean = True): TTMSFNCPropertyInfo;
    function FindProperty(var AObject: TObject; AName: string; AIndex: Integer = -1; AFindType: TTMSFNCDataBinderFindType = bftDontCare): TTMSFNCPropertyInfo;
    procedure DoBeforeWriteFieldToProperty(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField; var AAllow: Boolean); virtual;
    procedure DoAfterWriteFieldToProperty(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField); virtual;
    procedure DoBeforeWritePropertyToField(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField; var AAllow: Boolean); virtual;
    procedure DoAfterWritePropertyToField(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField); virtual;
    procedure DoBeforeWriteHTMLTemplateToProperty(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; var AHTMLTemplate: string; var AAllow: Boolean); virtual;
    procedure DoAfterWriteHTMLTemplateToProperty(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AHTMLTemplate: string); virtual;
    procedure WriteFieldToProperty(AObject: TObject; APropInfo: TTMSFNCPropertyInfo; AField: TField); virtual;
    procedure WritePropertyToField(AObject: TObject; APropInfo: TTMSFNCPropertyInfo; AField: TField); virtual;
    procedure WriteHTMLTemplateToProperty(AObject: TObject; APropInfo: TTMSFNCPropertyInfo; AHTMLTemplate: string); virtual;
    procedure ClearProperty(AObject: TObject; APropInfo: TTMSFNCPropertyInfo);
    {$IFDEF LCLLIB}
    function _AddRef : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    function _Release : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    {$ELSE}
    function _AddRef: Integer; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    function _Release: Integer; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    {$ENDIF}
  public
    {$IFDEF LCLLIB}
    function QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} iid : tguid;out obj) : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    {$ELSE}
    function QueryInterface(const IID: TGUID; out Obj): HResult; virtual; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    {$ENDIF}
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    function CheckDataSet: Boolean;
    function GetRecordCount: Integer;
    function HasDirty: Boolean;
    property DataLink: TTMSFNCDataBinderDataLink read FDataLink;
    procedure UpdateDataLink(AMode: TTMSFNCDataBinderDataLinkMode; ADistance: Integer = -1; AField: TField = nil);
    procedure WriteValueToField;
    property &Object: TObject read GetObject write SetObject;
    property ObjectInstance: TObject read GetObjectInstance write SetObjectInstance;
    function DataSetLocate(AKeyFieldNames: string; AKeyValues: string): Boolean;
    function DataSetIsEditing: Boolean;
    function DataSetIsInserting: Boolean;

    procedure NotifyValueChanged;
    procedure NotifyEdit;
    procedure NotifyPost;
    procedure NotifyUpdate;
    procedure NotifySetActiveRecord;

    procedure DataSetEdit;
    procedure DataSetPost;
    procedure DataSetInsert;
    procedure DataSetDelete;
    procedure DataSetCancel;
    procedure DataSetEnableControls;
    procedure DataSetDisableControls;
    procedure BeginUpdate;
    procedure EndUpdate;
    function DataSetCanModify: Boolean;

    property ControlValueMonitor: TTMSFNCDataBinderControlValueMonitor read GetControlValueMonitor;
    property EditLinkMonitor: TTMSFNCDataBinderEditLinkMonitor read GetEditLinkMonitor;
  published
    property BindComponent: TComponent read GetBindComponent write SetBindComponent;
    property PropertyName: string read FPropertyName write SetPropertyName;
    property ColumnsPropertyName: string read FColumnsPropertyName write SetColumnsPropertyName;
    property ColumnsSubPropertyName: string read FColumnsSubPropertyName write SetColumnsSubPropertyName;
    property SubPropertyNames: TTMSFNCDataBinderPropertyNames read FSubPropertyNames write FSubPropertyNames;
    property SubFieldNames: TTMSFNCDataBinderFieldNames read FSubFieldNames write FSubFieldNames;
    property DataSource: TDataSource read GetDataSource write SetDataSource;
    property Active: Boolean read FActive write SetActive default True;
    property BindType: TTMSFNCDataBinderBindType read FBindType write SetBindType default dbbtSingleValue;
    property FieldName: string read FFieldName write SetFieldName;
    property HTMLTemplate: string read FHTMLTemplate write SetHTMLTemplate;
    property BooleanStringValue: string read FBooleanStringValue write SetBooleanStringValue;
    property Name: string read FName write FName;
  end;

  {$IFDEF WEBLIB}
  TTMSFNCDataBinderItems = class(TTMSFNCOwnedCollection)
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCDataBinderItems = class({$IFDEF LCLLIB}specialize {$ENDIF}TTMSFNCOwnedCollection<TTMSFNCDataBinderItem>)
  {$ENDIF}
  private
    FOwner: TTMSFNCDataBinder;
    function GetItemEx(Index: Integer): TTMSFNCDataBinderItem;
    procedure SetItemEx(Index: Integer; const Value: TTMSFNCDataBinderItem);
  protected
    function GetDataBinderItemClass: TCollectionItemClass; virtual;
  public
    constructor Create(AOwner: TTMSFNCDataBinder);
    function Add: TTMSFNCDataBinderItem;
    function Insert(index: Integer): TTMSFNCDataBinderItem;
    property Items[Index: Integer]: TTMSFNCDataBinderItem read GetItemEx write SetItemEx; default;
  end;

  TTMSFNCDataBinderStringArray = array of string;

  TTMSFNCDataBinderPropertyList =  array of TTMSFNCPropertyInfo;

  TTMSFNCDataBinderBeforeWriteFieldToPropertyEvent = procedure(Sender: TObject; AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField; var AAllow: Boolean) of object;
  TTMSFNCDataBinderAfterWriteFieldToPropertyEvent = procedure(Sender: TObject; AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField) of object;
  TTMSFNCDataBinderBeforeWritePropertyToFieldEvent = procedure(Sender: TObject; AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField; var AAllow: Boolean) of object;
  TTMSFNCDataBinderAfterWritePropertyToFieldEvent = procedure(Sender: TObject; AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField) of object;
  TTMSFNCDataBinderBeforeWriteHTMLTemplateToPropertyEvent = procedure(Sender: TObject; AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; var AHTMLTemplate: string; var AAllow: Boolean) of object;
  TTMSFNCDataBinderAfterWriteHTMLTemplateToPropertyEvent = procedure(Sender: TObject; AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AHTMLTemplate: string) of object;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCDataBinder = class(TTMSFNCCustomComponent)
  private
    FDataSource: TDataSource;
    FUpdateCount: Integer;
    FItems: TTMSFNCDataBinderItems;
    FActive: Boolean;
    FOnAfterWriteFieldToProperty: TTMSFNCDataBinderAfterWriteFieldToPropertyEvent;
    FOnBeforeWriteFieldToProperty: TTMSFNCDataBinderBeforeWriteFieldToPropertyEvent;
    FOnAfterWritePropertyToField: TTMSFNCDataBinderAfterWritePropertyToFieldEvent;
    FOnBeforeWritePropertyToField: TTMSFNCDataBinderBeforeWritePropertyToFieldEvent;
    FOnAfterWriteHTMLTemplateToProperty: TTMSFNCDataBinderAfterWriteHTMLTemplateToPropertyEvent;
    FOnBeforeWriteHTMLTemplateToProperty: TTMSFNCDataBinderBeforeWriteHTMLTemplateToPropertyEvent;
    procedure SetItems(const Value: TTMSFNCDataBinderItems);
    function GetItems: TTMSFNCDataBinderItems;
    procedure SetActive(const Value: Boolean);
    function GetItemByName(AName: string): TTMSFNCDataBinderItem;
    function GetItemByObject(AObject: TObject; APropertyName: string): TTMSFNCDataBinderItem;
    function GetDataSource: TDataSource;
    procedure SetDataSource(const Value: TDataSource);
  protected
    function GetDocURL: string; override;
    function GetInstance: NativeUInt; override;
    function GetVersion: string; override;
    function CreateItems: TTMSFNCDataBinderItems; virtual;
    procedure DoBeforeWriteFieldToProperty(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField; var AAllow: Boolean); virtual;
    procedure DoAfterWriteFieldToProperty(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField); virtual;
    procedure DoBeforeWritePropertyToField(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField; var AAllow: Boolean); virtual;
    procedure DoAfterWritePropertyToField(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AField: TField); virtual;
    procedure DoBeforeWriteHTMLTemplateToProperty(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; var AHTMLTemplate: string; var AAllow: Boolean); virtual;
    procedure DoAfterWriteHTMLTemplateToProperty(AObject: TObject; AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string; APropertyKind: TTypeKind; AHTMLTemplate: string); virtual;
    procedure RegisterRuntimeClasses; override;
    procedure UpdateDataLinks;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
  public
    constructor Create; reintroduce; overload; virtual;
    constructor Create(AOwner: TComponent); overload; override;
    destructor Destroy; override;
    procedure BeginUpdate; override;
    procedure EndUpdate; override;
    function ItemCount: Integer;
    function HasEditLinkMonitor(AObject: TObject): Boolean;
    function HasControlValueMonitor(AObject: TObject): Boolean;
    property ItemByName[AName: string]: TTMSFNCDataBinderItem read GetItemByName;
    property ItemByObject[AObject: TObject; APropertyName: string]: TTMSFNCDataBinderItem read GetItemByObject;
    procedure GetDataSources(AStrings: TStrings);
    class function GetPropertyList(AObject: TObject): TTMSFNCDataBinderPropertyList; overload;
    class function GetPropertyNames(AObject: TObject; IncludePublic: Boolean = True): TTMSFNCDataBinderStringArray; overload;
    class function GetPropertyList(AObject: TObject; IncludePublic: Boolean): TTMSFNCDataBinderPropertyList; overload;

    class procedure BlobFieldToBitmap(AField: TField; ABitmap: TTMSFNCBitmap);
    class procedure BitmapToBlobField(AField: TField; ABitmap: TTMSFNCBitmap);

    procedure NotifyEdit;
    procedure NotifyValueChanged;
    procedure NotifyPost;
    procedure NotifyUpdate;
    procedure NotifySetActiveRecord;

    function IsConnected(AObject: TObject): Boolean;
    function ConnectSingleHTMLTemplate(AObject: TObject; ADataSource: TDataSource; APropertyName: string; AHTMLTemplate: string): TTMSFNCDataBinderItem;
    function ConnectSingle(AObject: TObject; ADataSource: TDataSource; APropertyName: string; AFieldName: string): TTMSFNCDataBinderItem;
    function ConnectListHTMLTemplate(AObject: TObject; ADataSource: TDataSource; APropertyName: string; ASubPropertyNames: TTMSFNCDataBinderStringArray; ASubHTMLTemplates: TTMSFNCDataBinderStringArray): TTMSFNCDataBinderItem; overload;
    function ConnectList(AObject: TObject; ADataSource: TDataSource; APropertyName: string; ASubPropertyNames: TTMSFNCDataBinderStringArray; ASubFieldNames: TTMSFNCDataBinderStringArray): TTMSFNCDataBinderItem; overload;
    function ConnectListHTMLTemplate(AObject: TObject; ADataSource: TDataSource; APropertyName: string; AHTMLTemplate: string): TTMSFNCDataBinderItem; overload;
    function ConnectList(AObject: TObject; ADataSource: TDataSource; APropertyName: string; AFieldName: string): TTMSFNCDataBinderItem; overload;
    function ConnectColumnList(AObject: TObject; ADataSource: TDataSource; AListPropertyName: string; AColumnsPropertyName: string; AColumnsSubPropertyName: string; AListSubPropertyName: string): TTMSFNCDataBinderItem;
    function Connect(AObject: TObject; ADataSource: TDataSource; APropertyName: string; AFieldName: string = ''; AHTMLTemplate: string = ''; ASubPropertyNames: TTMSFNCDataBinderStringArray = nil; ASubFieldNames: TTMSFNCDataBinderStringArray = nil; ASubHTMLTemplates: TTMSFNCDataBinderStringArray = nil; ABindType: TTMSFNCDataBinderBindType = dbbtSingleValue): TTMSFNCDataBinderItem;
    function ConnectGrid(AObject: TObject; ADatasource: TDataSource): TTMSFNCDataBinderItem;
    procedure StartEditor(const AObject: TObject = nil);
  published
    property DataSource: TDataSource read GetDataSource write SetDataSource;
    property Items: TTMSFNCDataBinderItems read GetItems write SetItems;
    property Version: string read GetVersion;
    property Active: Boolean read FActive write SetActive default False;
    property OnBeforeWriteFieldToProperty: TTMSFNCDataBinderBeforeWriteFieldToPropertyEvent read FOnBeforeWriteFieldToProperty write FOnBeforeWriteFieldToProperty;
    property OnAfterWriteFieldToProperty: TTMSFNCDataBinderAfterWriteFieldToPropertyEvent read FOnAfterWriteFieldToProperty write FOnAfterWriteFieldToProperty;
    property OnBeforeWritePropertyToField: TTMSFNCDataBinderBeforeWritePropertyToFieldEvent read FOnBeforeWritePropertyToField write FOnBeforeWritePropertyToField;
    property OnAfterWritePropertyToField: TTMSFNCDataBinderAfterWritePropertyToFieldEvent read FOnAfterWritePropertyToField write FOnAfterWritePropertyToField;
    property OnBeforeWriteHTMLTemplateToProperty: TTMSFNCDataBinderBeforeWriteHTMLTemplateToPropertyEvent read FOnBeforeWriteHTMLTemplateToProperty write FOnBeforeWriteHTMLTemplateToProperty;
    property OnAfterWriteHTMLTemplateToProperty: TTMSFNCDataBinderAfterWriteHTMLTemplateToPropertyEvent read FOnAfterWriteHTMLTemplateToProperty write FOnAfterWriteHTMLTemplateToProperty;
  end;

implementation

uses
  WEBLib.Graphics, WEBLib.Forms, WEBLib.TMSFNCUtils, WEBLib.TMSFNCCustomControl, SysUtils,
  WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes, WEBLib.TMSFNCDataBindingEditor
  {$IFNDEF WEBLIB}
  ,Variants
  {$ENDIF}
  {$IFDEF VCLLIB}
  , JPEG
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  ,RTTI
  {$ENDIF}
  ;

{$R 'TMSFNCDataBinding.res'}

var
  FGlobalUpdating: Boolean;

var
  FManager: TTMSFNCDataBinderNotificationManager;

function DataBinderNotificationManager: TTMSFNCDataBinderNotificationManager;
begin
  Result := FManager;
end;

{ TTMSFNCDataBinderItem }

procedure TTMSFNCDataBinderItem.Assign(Source: TPersistent);
begin
  FActive := (Source as TTMSFNCDataBinderItem).Active;
  FSubPropertyNames.Assign((Source as TTMSFNCDataBinderItem).SubPropertyNames);
  FSubFieldNames.Assign((Source as TTMSFNCDataBinderItem).SubFieldNames);
  FBindType := (Source as TTMSFNCDataBinderItem).BindType;
  FFieldName := (Source as TTMSFNCDataBinderItem).FieldName;
  FHTMLTemplate := (Source as TTMSFNCDataBinderItem).HTMLTemplate;
  FPropertyName := (Source as TTMSFNCDataBinderItem).PropertyName;
  FObject := (Source as TTMSFNCDataBinderItem).&Object;
  FColumnsPropertyName := (Source as TTMSFNCDataBinderItem).ColumnsPropertyName;
  DataSource := (Source as TTMSFNCDataBinderItem).DataSource;
end;

procedure TTMSFNCDataBinderItem.DataSetCancel;
begin
  if CheckDataSet then
    DataLink.DataSet.Cancel;
end;

function TTMSFNCDataBinderItem.DataSetCanModify: Boolean;
begin
  Result := False;
  if CheckDataSet then
    Result := DataLink.DataSet.CanModify;
end;

procedure TTMSFNCDataBinderItem.BeginUpdate;
begin
  FUpdating := True;
end;

function TTMSFNCDataBinderItem.CheckDataSet: Boolean;
begin
  Result := Active and Assigned(FDataLink.DataSet) and (FDataLink.DataSet.Active);
end;

procedure TTMSFNCDataBinderItem.ClearProperty(AObject: TObject;
  APropInfo: TTMSFNCPropertyInfo);
var
  pName, cn: string;
  k: TTypeKind;
  p: TTMSFNCPropertyInfo;
  o: TObject;
  i: Integer;
  s: string;
  b: Boolean;
  d: Double;
  dt: TDateTime;
  ii: Int64;
  ob: TObject;
  bt: TTMSFNCBitmap;
  {$IFDEF VCLLIB}
  pic: TPicture;
  {$ELSE}
  pic: TBitmap;
  {$ENDIF}
begin
  if not Assigned(AObject) or not Assigned(APropInfo) then
    Exit;

  o := AObject;
  p := APropInfo;
  pName := TTMSFNCPersistence.GetPropInfoName(p);
  k := TTMSFNCPersistence.GetPropInfoType(p);

  try
    case k of
      tkClass:
      begin
        ob := GetObjectProp(o, p);
        if Assigned(ob) then
        begin
          cn := TTMSFNCPersistence.GetPropInfoTypeName(p);

          if ob is TCollection then
          begin
            (ob as TCollection).Clear;
          end
          else if ob is TStrings then
          begin
            (ob as TStrings).Clear;
          end
          else if ob is TStream then
          begin
            (ob as TStream).Size := 0;
            (ob as TStream).Position := 0;
          end
          else if ob is TTMSFNCBitmap then
          begin
            bt := ob as TTMSFNCBitmap;
            bt.Assign(nil);
          end
          {$IFDEF VCLLIB}
          else if ob is TPicture then
          begin
            pic := ob as TPicture;
            pic.Assign(nil);
          end
          {$ELSE}
          else if ob is TBitmap then
          begin
            pic := ob as TBitmap;
            pic.Assign(nil);
          end
          {$ENDIF}
          else if TTMSFNCPersistence.IsGenericList(ob.ClassType, 'String') then
          begin
            TTMSFNCStringList(ob).Clear;
          end
          else if TTMSFNCPersistence.IsGenericList(ob.ClassType, 'Integer') then
          begin
            TTMSFNCIntegerList(ob).Clear;
          end
          else if ob is TPersistent then
          begin
          end
          else
          begin
          end;
        end;
      end;

      tkInteger:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

        i := 0;
        SetOrdProp(o, p, i);
      end;

      {$IFNDEF WEBLIB}tkWChar, tkLString, tkUString,{$ENDIF}tkChar, tkString{$IFDEF LCLLIB},tkAString{$ENDIF}:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

        s := '';
        SetStrProp(o, p, s);
      end;

      tkEnumeration:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

        if TTMSFNCPersistence.GetPropInfoDataTypeInfo(p) = TypeInfo(Boolean) then
        begin
          b := False;
          SetOrdProp(o, p, Ord(b));
        end
        else
        begin
          i := 0;
          SetOrdProp(o, p, i);
        end;
      end;

      {$IFDEF LCLWEBLIB}
      tkBool:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

        b := False;
        SetOrdProp(o, p, Ord(b));
      end;
      {$ENDIF}

      tkFloat:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

        cn := TTMSFNCPersistence.GetPropInfoTypeName(p);
        if (CompareText(cn, 'TDateTime') = 0) or
           (CompareText(cn, 'TDate') = 0) or
           (CompareText(cn, 'TTime') = 0) then
        begin
          dt := 0;
          SetFloatProp(o, p, dt);
        end
        else
        begin
          d := 0.0;
          SetFloatProp(o, p, d);
        end;
      end;

      {$IFNDEF WEBLIB}
      tkInt64:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

        ii := 0;
        SetInt64Prop(o, p, ii);
      end;
      {$ENDIF}

      tkSet:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

        i := 0;
        SetOrdProp(o, p, i);
      end;

      {$IFNDEF WEBLIB}
      tkVariant:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

        SetVariantProp(o, p, Null);
      end;
      {$ENDIF}

      tkArray, tkDynArray:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

      end;

      tkRecord:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

      end;

      tkInterface:
      begin
        if TTMSFNCPersistence.IsReadOnly(p) then
          Exit;

        SetInterfaceProp(o, p, nil);
      end;
    end;
  except
    on E: Exception do
    begin
    end;
  end;
end;

constructor TTMSFNCDataBinderItem.Create(ACollection: TCollection);
begin
  inherited;
  FDirty := False;
  FActive := True;
  FBufferCount := 0;
  FDataBinder := (Collection as TTMSFNCDataBinderItems).FOwner;
  FDataLink := TTMSFNCDataBinderDataLink.Create(Self);
  FSubPropertyNames := TTMSFNCDataBinderPropertyNames.Create(Self);
  FSubFieldNames := TTMSFNCDataBinderFieldNames.Create(Self);

  if Assigned(FDataBinder) and Assigned(FDataBinder.DataSource) then
    DataSource := FDataBinder.DataSource;
end;

procedure TTMSFNCDataBinderItem.DataSetDelete;
begin
  if CheckDataSet then
    DataLink.DataSet.Delete;
end;

procedure TTMSFNCDataBinderItem.DataSetDisableControls;
begin
  if CheckDataSet then
    DataLink.DataSet.DisableControls;
end;

destructor TTMSFNCDataBinderItem.Destroy;
begin
  DestroyMonitors;

  if Assigned(FDataBinder) and not (FDataBinder.IsDestroying) then
    &Object := nil
  else
  begin
    FObject := nil;
    FManager.Remove(Self);
  end;

  FDataBinder := nil;
  FSubPropertyNames.Free;
  FSubFieldNames.Free;
  FDataLink.Free;
  inherited;
end;

procedure TTMSFNCDataBinderItem.DoAfterWriteFieldToProperty(AObject: TObject;
  AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo;
  APropertyName: string; APropertyKind: TTypeKind; AField: TField);
begin
  if Assigned(FDataBinder) then
    FDataBinder.DoAfterWriteFieldToProperty(AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AField);
end;

procedure TTMSFNCDataBinderItem.DoAfterWritePropertyToField(AObject: TObject;
  AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo;
  APropertyName: string; APropertyKind: TTypeKind; AField: TField);
begin
  if Assigned(FDataBinder) then
    FDataBinder.DoAfterWritePropertyToField(AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AField);
end;

procedure TTMSFNCDataBinderItem.DoAfterWriteHTMLTemplateToProperty(
  AObject: TObject; AItem: TTMSFNCDataBinderItem;
  APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string;
  APropertyKind: TTypeKind; AHTMLTemplate: string);
begin
  if Assigned(FDataBinder) then
    FDataBinder.DoAfterWriteHTMLTemplateToProperty(AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AHTMLTemplate);
end;

procedure TTMSFNCDataBinderItem.DoBeforeWritePropertyToField(AObject: TObject;
  AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo;
  APropertyName: string; APropertyKind: TTypeKind; AField: TField;
  var AAllow: Boolean);
begin
  if Assigned(FDataBinder) then
    FDataBinder.DoBeforeWritePropertyToField(AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AField, AAllow);
end;

procedure TTMSFNCDataBinderItem.DoBeforeWriteFieldToProperty(AObject: TObject;
  AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo;
  APropertyName: string; APropertyKind: TTypeKind; AField: TField;
  var AAllow: Boolean);
begin
  if Assigned(FDataBinder) then
    FDataBinder.DoBeforeWriteFieldToProperty(AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AField, AAllow);
end;

procedure TTMSFNCDataBinderItem.DoBeforeWriteHTMLTemplateToProperty(
  AObject: TObject; AItem: TTMSFNCDataBinderItem;
  APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string;
  APropertyKind: TTypeKind; var AHTMLTemplate: string; var AAllow: Boolean);
begin
  if Assigned(FDataBinder) then
    FDataBinder.DoBeforeWriteHTMLTemplateToProperty(AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AHTMLTemplate, AAllow);
end;

procedure TTMSFNCDataBinderItem.DestroyMonitors;
begin
  FreeAndNil(FControlValueMonitor);
  FreeAndNil(FEditLinkMonitor);
end;

procedure TTMSFNCDataBinderItem.EndUpdate;
begin
  FUpdating := False;
end;

procedure TTMSFNCDataBinderItem.DoChanged(Sender: TObject);
begin
  UpdateDataLink(dlmActiveChanged);
end;

procedure TTMSFNCDataBinderItem.DataSetEdit;
begin
  if CheckDataSet and not DataSetIsEditing then
    DataLink.DataSet.Edit;
end;

procedure TTMSFNCDataBinderItem.DataSetEnableControls;
begin
  if CheckDataSet then
    DataLink.DataSet.EnableControls;
end;

procedure TTMSFNCDataBinderItem.DataSetInsert;
begin
  if CheckDataSet then
    DataLink.DataSet.Insert;
end;

function TTMSFNCDataBinderItem.DataSetIsEditing: Boolean;
begin
  Result := False;
  if CheckDataSet then
    Result := (DataLink.DataSet.State = dsEdit);
end;

function TTMSFNCDataBinderItem.DataSetIsInserting: Boolean;
begin
  Result := False;
  if CheckDataSet then
    Result := (DataLink.DataSet.State = dsInsert);
end;

function TTMSFNCDataBinderItem.InternalFindProperty(AObject: TObject;
  AName: string; AFindType: TTMSFNCDataBinderFindType = bftDontCare;
  IncludePublic: Boolean = True): TTMSFNCPropertyInfo;
var
  {$IFNDEF WEBLIB}
  ci: Pointer;
  c: Integer;
  pl: PPropList;
  {$ENDIF}
  {$IFDEF WEBLIB}
  ci: TTypeInfoClass;
  a: TTypeMemberPropertyDynArray;
  {$ENDIF}
  p: TTMSFNCPropertyInfo;
  pName: string;
  I: Integer;
  k: TTypeKind;

  {$IFNDEF LCLWEBLIB}
  rttiContext: TRttiContext;
  rttiType: TRttiType;
  rttiProp: TRttiProperty;
  rttiProps: TArray<TRttiProperty>;
  {$ENDIF}
begin
  Result := nil;
  if not Assigned(AObject) then
    Exit;

  {$IFNDEF LCLWEBLIB}
  if IncludePublic then
  begin
    try
      rttiContext := TRttiContext.Create;
      try
        rttiType := rttiContext.GetType(AObject.ClassType);
        if Assigned(rttiType) then
        begin
          rttiProps := rttiType.GetProperties;
          for rttiProp in rttiProps do
          begin
            pName := rttiProp.Name;

            p := nil;
            if rttiProp is TRttiInstanceProperty then
              p := (rttiProp as TRttiInstanceProperty).PropInfo;

            if Assigned(p) then
            begin
              k := TTMSFNCPersistence.GetPropInfoType(p);
              if (UpperCase(pName) = UpperCase(AName)) and
                 ((AFindType = bftDontCare) or
                  ((AFindType = bftClass) and (k = tkClass)) or
                  ((AFindType = bftString) and (k in [{$IFNDEF WEBLIB}tkWChar, tkLString, tkUString,{$ENDIF}tkChar, tkString{$IFDEF LCLLIB},tkAString{$ENDIF}]))) then
              begin
                Result := p;
                Exit;
              end;
            end;
          end;
        end;
      finally
        rttiContext.Free;
      end;
    except
    end;
  end;
  {$ENDIF}

  {$IFNDEF WEBLIB}
  ci := AObject.ClassInfo;
  c := GetPropList(ci, tkProperties, nil);
  GetMem(pl, c * SizeOf(TTMSFNCPropertyInfo));
  {$ENDIF}
  {$IFDEF WEBLIB}
  ci := TypeInfo(AObject);
  {$ENDIF}
  try
    {$IFNDEF WEBLIB}
    GetPropList(ci, tkProperties, pl);
    for I := 0 to c - 1 do
    begin
      p := pl^[i];
    {$ENDIF}
    {$IFDEF WEBLIB}
    a := GetPropList(ci, tkProperties);
    for I := 0 to Length(a) - 1 do
    begin
      p := a[I];
    {$ENDIF}
      pName := TTMSFNCPersistence.GetPropInfoName(p);
      k := TTMSFNCPersistence.GetPropInfoType(p);
      if (UpperCase(pName) = UpperCase(AName)) and ((AFindType = bftDontCare)
        or ((AFindType = bftClass) and (k = tkClass))
        or ((AFindType = bftString) and (k in [{$IFNDEF WEBLIB}tkWChar, tkLString, tkUString,{$ENDIF}tkChar, tkString{$IFDEF LCLLIB},tkAString{$ENDIF}]))
        ) then
      begin
        Result := p;
        Break;
      end;
    end;
  finally
    {$IFNDEF WEBLIB}
    FreeMem(pl);
    {$ENDIF}
  end;
end;

function TTMSFNCDataBinderItem.IsRequired: Boolean;
var
  f: TField;
begin
  Result := False;
  f := Field;
  if Assigned(f) then
    Result := f.Required;
end;

function TTMSFNCDataBinderItem.IsValidChar(const AChar: Char): Boolean;
var
  f: TField;
begin
  Result := False;
  f := Field;
  if Assigned(f) then
  begin
    if AChar = #0 then
      Result := f.CanModify
    else
      Result := f.IsValidChar(AChar);
  end;
end;

procedure TTMSFNCDataBinderItem.Modified;
begin
  FDirty := True;
end;

procedure TTMSFNCDataBinderItem.Notify(AType: TTMSFNCDataBinderNotificationType);
var
  bs: ITMSFNCDataBinderSelection;
  r: Integer;
begin
  if CheckDataSet and not FUpdating and not FGlobalUpdating then
  begin
    case AType of
      dbntSetActiveRecord:
      begin
        FUpdating := True;
        try
          if Supports(&Object, ITMSFNCDataBinderSelection, bs) then
          begin
            r := bs.DataGetItemIndex + 1;
            if r >= 1 then
              FDataLink.DataSource.DataSet.RecNo := r;
          end;
        finally
          FUpdating := False;
        end;
      end;
      dbntUpdate: UpdateDataLink(dlmUpdateData);
      dbntEdit: DataSetEdit;
      dbntValueChanged: WriteValueToField;
      dbntPost: DataSetPost;
    end;
  end;
end;

procedure TTMSFNCDataBinderItem.NotifyEdit;
begin
  Notify(dbntEdit);
end;

procedure TTMSFNCDataBinderItem.NotifyPost;
begin
  Notify(dbntPost);
end;

procedure TTMSFNCDataBinderItem.NotifySetActiveRecord;
begin
  Notify(dbntSetActiveRecord);
end;

procedure TTMSFNCDataBinderItem.NotifyUpdate;
begin
  Notify(dbntUpdate);
end;

procedure TTMSFNCDataBinderItem.NotifyValueChanged;
begin
  Notify(dbntValueChanged);
end;

function TTMSFNCDataBinderItem.DataSetLocate(AKeyFieldNames, AKeyValues: string): Boolean;
begin
  Result := False;
  if CheckDataSet then
    Result := DataLink.DataSet.Locate(AKeyFieldNames, AKeyValues, []);
end;

procedure TTMSFNCDataBinderItem.DataSetPost;
begin
  if CheckDataSet and DataSetIsEditing then
  begin
    if not HasDirty then
      DataLink.DataSet.Post;
  end;
end;

function TTMSFNCDataBinderItem.GetBindComponent: TComponent;
begin
  Result := nil;
  if Assigned(FObject) and (FObject is TComponent) then
    Result := TComponent(FObject);
end;

function TTMSFNCDataBinderItem.GetDataSource: TDataSource;
begin
  Result := DataLink.DataSource;
end;

function TTMSFNCDataBinderItem.GetField: TField;
begin
  Result := nil;
  if CheckDataSet then
  begin
    if FieldName <> '' then
      Result := DataLink.DataSet.FieldByName(FieldName);
  end;
end;

function TTMSFNCDataBinderItem.GetCanModify: Boolean;
var
  f: TField;
begin
  Result := False;
  f := Field;
  if Assigned(f) then
    Result := {not ReadOnly and }(f.CanModify);
end;

function TTMSFNCDataBinderItem.GetDisplayName: string;
begin
  if FName <> '' then
    Result := FName
  {$IFDEF WEBLIB}
  else
    Result := '';
  {$ENDIF}
  {$IFNDEF WEBLIB}
  else
    Result := inherited;
  {$ENDIF}
end;

function TTMSFNCDataBinderItem.GetComponent: TComponent;
begin
  Result := nil;
  if Assigned(&Object) and (&Object is TComponent) then
    Result := (&Object as TComponent);
end;

function TTMSFNCDataBinderItem.GetControlValueMonitor: TTMSFNCDataBinderControlValueMonitor;
begin
  if not Assigned(FControlValueMonitor) and not FDataBinder.HasEditLinkMonitor(&Object) and not FDataBinder.HasControlValueMonitor(&Object) then
  begin
    FControlValueMonitor := TTMSFNCDataBinderControlValueMonitor.Create(Self);
    FControlValueMonitor.StartMonitoring;
  end;

  Result := FControlValueMonitor;
end;

function TTMSFNCDataBinderItem.GetEditLinkMonitor: TTMSFNCDataBinderEditLinkMonitor;
begin
  if not Assigned(FEditLinkMonitor) and not FDataBinder.HasEditLinkMonitor(&Object) then
  begin
    FEditLinkMonitor := TTMSFNCDataBinderEditLinkMonitor.Create(Self);
    FEditLinkMonitor.StartMonitoring;
  end;

  Result := FEditLinkMonitor;
end;

function TTMSFNCDataBinderItem.GetObject: TObject;
begin
  Result := FObject;
end;

function TTMSFNCDataBinderItem.GetObjectInstance: TObject;
begin
  Result := &Object;
end;

function TTMSFNCDataBinderItem.GetRecordCount: Integer;
begin
  Result := 0;
  if not CheckDataSet then
    Exit;

  if DataSource.State = dsSetKey then
    Result := 1
  else
  begin
    Result := DataSource.DataSet.RecordCount;

    if (DataLink.DataSet.State in [dsInsert]) then
      Result := Result + 1;
  end;
end;

function TTMSFNCDataBinderItem.HasDirty: Boolean;
var
  I: Integer;
begin
  Result := False;
  if Assigned(FDataBinder) then
  begin
    for I := 0 to FDataBinder.ItemCount - 1 do
    begin
      if FDataBinder.Items[I].FDirty then
      begin
        Result := True;
        Break;
      end;
    end;
  end;
end;

function TTMSFNCDataBinderItem.HasControlValueMonitor: Boolean;
begin
  Result := Assigned(FControlValueMonitor);
end;

function TTMSFNCDataBinderItem.HasEditLinkMonitor: Boolean;
begin
  Result := Assigned(FEditLinkMonitor);
end;

function TTMSFNCDataBinderItem.HTMLDBReplace(AValue: string; ADataset: TDataSet): string;
var
  beforetag, aftertag, fld, dbfld: string;
  i, j: integer;
  AField: TField;
begin
  beforetag := '';

  while Pos('<#', AValue) > 0 do
  begin
    i := pos('<#', AValue);
    beforetag := beforetag + copy(AValue, 1, i - 1);
    aftertag := copy(AValue, i, length(AValue));
    j := pos('>', aftertag);
    fld := copy(aftertag, 1, j - 1);
    Delete(fld, 1, 2);
    Delete(AValue, 1, i + j - 1);

    dbfld := '';
    if Assigned(ADataSet) then
    begin
      if ADataSet.Active then
      begin
        AField := ADataSet.FindField(fld);
        if Assigned(AField) then
        begin
          if AField.IsBlob then
          begin
            if Assigned(AField.OnGetText) then
              dbfld := AField.DisplayText
            else
              dbfld := AField.AsString;
          end
          else
           dbfld := AField.DisplayText;
        end;

//        if Assigned(FOnGetHTMLTemplateData) then
//          FOnGetHTMLTemplateData(Self, fld, dbfld);
      end
      else
        dbfld := '(' + fld + ')';
    end
    else
      dbfld := '(' + fld + ')';

    beforetag := beforetag + dbfld;
  end;

  Result := beforetag + AValue;
end;

function TTMSFNCDataBinderItem.FindProperty(var AObject: TObject;
  AName: string; AIndex: Integer = -1; AFindType: TTMSFNCDataBinderFindType = bftDontCare): TTMSFNCPropertyInfo;
var
  sl: TStringList;
  I: Integer;
  p: TTMSFNCPropertyInfo;
  o: TObject;
begin
  o := AObject;
  Result := nil;
  if not Assigned(o) then
    Exit;

  sl := TStringList.Create;
  try
    TTMSFNCUtils.Split('.', AName, sl);
    for I := 0 to sl.Count - 1 do
    begin
      p := InternalFindProperty(o, sl[I], AFindType);
      if Assigned(p) then
      begin
        if (I = 0) and (sl.Count > 1) and (TTMSFNCPersistence.GetPropInfoType(p) = tkClass) then
        begin
          o := GetObjectProp(o, p);
          if o is TCollection then
          begin
            if (AIndex >= 0) and (AIndex <= (o as TCollection).Count - 1) then
              o := (o as TCollection).Items[AIndex]
            else
              o := (o as TCollection).Add;
          end;
        end
        else
        begin
          Result := p;
          Break;
        end;
      end;
    end;          

    AObject := o;        
  finally
    sl.Free;
  end;
end;

procedure TTMSFNCDataBinderItem.SetActive(const Value: Boolean);
begin
  if FActive <> Value then
  begin
    FActive := Value;
    UpdateDataLink(dlmActiveChanged);
  end;
end;

procedure TTMSFNCDataBinderItem.SetBindComponent(const Value: TComponent);
begin
  &Object := Value;
end;

procedure TTMSFNCDataBinderItem.SetBooleanStringValue(const Value: string);
begin
  if FBooleanStringValue <> Value then
  begin
    FBooleanStringValue := Value;
    UpdateDataLink(dlmActiveChanged);
  end;
end;

procedure TTMSFNCDataBinderItem.SetBufferCount(const Value: Integer);
begin
  if FBufferCount <> Value then
  begin
    FBufferCount := Value;
    if Assigned(DataLink) then
      DataLink.BufferCount := FBufferCount;

    UpdateDataLink(dlmActiveChanged);
  end;
end;

procedure TTMSFNCDataBinderItem.SetColumnsPropertyName(const Value: string);
begin
  if FColumnsPropertyName <> Value then
  begin
    FColumnsPropertyName := Value;
    UpdateDataLink(dlmActiveChanged);
  end;
end;

procedure TTMSFNCDataBinderItem.SetColumnsSubPropertyName(const Value: string);
begin
  if FColumnsSubPropertyName <> Value then
  begin
    FColumnsSubPropertyName := Value;
    UpdateDataLink(dlmActiveChanged);
  end;
end;

procedure TTMSFNCDataBinderItem.SetDataSource(const Value: TDataSource);
begin
  if Value = DataLink.Datasource then
    Exit;

  DataLink.DataSource := Value;

  if not Assigned(DataLink.DataSource) then
  begin
    FSubFieldNames.Clear;
    FSubPropertyNames.Clear;
    FFieldName := '';
    UpdateDataLink(dlmActiveChanged);
  end;

  if Value <> nil then
    Value.FreeNotification(FDataBinder);
end;

procedure TTMSFNCDataBinderItem.SetBindType(const Value: TTMSFNCDataBinderBindType);
begin
  if FBindType <> Value then
  begin
    FBindType := Value;
    UpdateDataLink(dlmActiveChanged);
  end;
end;

procedure TTMSFNCDataBinderItem.SetFieldName(const Value: string);
begin
  if FFieldName <> Value then
  begin
    FFieldName := Value;
    DestroyMonitors;
    UpdateDataLink(dlmUpdateData);
  end;
end;

procedure TTMSFNCDataBinderItem.SetHTMLTemplate(const Value: string);
begin
  if FHTMLTemplate <> Value then
  begin
    FHTMLTemplate := Value;
    UpdateDataLink(dlmActiveChanged);
  end;
end;

procedure TTMSFNCDataBinderItem.SetIsReadOnly(const AValue: Boolean);
begin
//
end;

procedure TTMSFNCDataBinderItem.SetObject(const Value: TObject);
var
  m: ITMSFNCDataBinderNotificationManagerReference;
begin
  if Assigned(FObject) and not Assigned(Value) then
  begin
    FManager.Remove(Self);
    if not FManager.HasObject(FObject) and Supports(FObject, ITMSFNCDataBinderNotificationManagerReference, m) then
      m.RemoveManager;
  end;

  if Assigned(FObject) and (FObject <> Value) then
    DestroyMonitors;

  FObject := Value;

  if Assigned(FObject) then
  begin
    FManager.Add(Self);
    if Supports(FObject, ITMSFNCDataBinderNotificationManagerReference, m) then
      m.AddManager(FManager);
  end;

  UpdateDataLink(dlmActiveChanged);
end;

procedure TTMSFNCDataBinderItem.SetObjectInstance(const Value: TObject);
begin
  &Object := Value;
end;

procedure TTMSFNCDataBinderItem.SetPropertyName(const Value: string);
begin
  if FPropertyName <> Value then
  begin
    FPropertyName := Value;
    UpdateDataLink(dlmActiveChanged);
  end;
end;

procedure TTMSFNCDataBinderItem.UpdateDataLink(AMode: TTMSFNCDataBinderDataLinkMode; ADistance: Integer = -1; AField: TField = nil);
var
  p, pcol, psub: TTMSFNCPropertyInfo;
  f: TField;
  h: string;
  k: TTypeKind;
  o, oc, no: TObject;
  its: TCollection;
  sl: TStrings;
  gls: TTMSFNCStringList;
  gli: TTMSFNCIntegerList;
  itv, it, cit: TObject;
  col: TCollection;
  colit: TObject;
  I, J, L: Integer;
  cb: TBookmark;
  ai: Integer;
  dbb: ITMSFNCDataBinderBase;
  dbg: ITMSFNCDataBinderGrid;
  em, um: Boolean;
  elm: TTMSFNCDataBinderEditLinkMonitor;
  cvm: TTMSFNCDataBinderControlValueMonitor;

  procedure UpdateItem(AItem: TObject);
  var
    kj: Integer;
  begin
    for kj := 0 to SubPropertyNames.Count - 1 do
    begin
      if (kj >= 0) and (kj <= SubFieldNames.Count - 1) then
      begin
        f := nil;
        if SubFieldNames[kj].Value <> '' then
          f := DataLink.DataSet.FieldByName(SubFieldNames[kj].Value);

        if Assigned(f) then
        begin
          itv := AItem;
          psub := FindProperty(itv, SubPropertyNames[kj].Value, kj);
          if Assigned(psub) then
            WriteFieldToProperty(itv, psub, f);
        end
        else if SubFieldNames[kj].HTMLTemplate <> '' then
        begin
          itv := AItem;
          psub := FindProperty(itv, SubPropertyNames[kj].Value, kj);
          if Assigned(psub) then
            WriteHTMLTemplateToProperty(itv, psub, SubFieldNames[kj].HTMLTemplate);
        end;
      end
      else if FieldName <> '' then
      begin
        f := DataLink.DataSet.FieldByName(FieldName);
        if Assigned(f) then
        begin
          itv := AItem;
          psub := FindProperty(itv, SubPropertyNames[kj].Value, kj);
          if Assigned(psub) then
            WriteFieldToProperty(itv, psub, f);
        end;
      end
      else if HTMLTemplate <> '' then
      begin
        itv := AItem;
        psub := FindProperty(itv, SubPropertyNames[kj].Value, kj);
        if Assigned(psub) then
          WriteHTMLTemplateToProperty(itv, psub, HTMLTemplate);
      end;
    end;
  end;

  procedure DoBeginUpdate;
  begin
    FUpdating := True;
    FGlobalUpdating := True;
    if no is TTMSFNCCustomComponent then
      (no as TTMSFNCCustomComponent).BeginUpdate
    else if no is TTMSFNCCustomControl then
      (no as TTMSFNCCustomControl).BeginUpdate
    else if Supports(no, ITMSFNCDataBinderGrid, dbg) then
      dbg.DataBeginUpdate
    else if Supports(no, ITMSFNCDataBinderBase, dbb) then
      dbb.DataBeginUpdate;
  end;

  procedure DoEndUpdate;
  begin
    if no is TTMSFNCCustomComponent then
      (no as TTMSFNCCustomComponent).EndUpdate
    else if no is TTMSFNCCustomControl then
      (no as TTMSFNCCustomControl).EndUpdate
    else if Supports(no, ITMSFNCDataBinderGrid, dbg) then
      dbg.DataEndUpdate
    else if Supports(no, ITMSFNCDataBinderBase, dbb) then
      dbb.DataEndUpdate;

    FUpdating := False;
    FGlobalUpdating := False;
  end;

  procedure SetActiveItemIndex;
  var
    bs: ITMSFNCDataBinderSelection;
  begin
    if Supports(no, ITMSFNCDataBinderSelection, bs) then
    begin
      if not DataSetIsInserting then
        bs.DataSetItemIndex(FDataLink.DataSource.DataSet.RecNo - 1)
      else
        bs.DataSetItemIndex(bs.DataGetItemIndex);
    end;
  end;

  function GetActiveItemIndex: Integer;
  var
    bs: ITMSFNCDataBinderSelection;
  begin
    Result := -1;
    if not DataSetIsInserting then
      Result := FDataLink.DataSource.DataSet.RecNo - 1
    else
    begin
      if Supports(no, ITMSFNCDataBinderSelection, bs) then
        Result := bs.DataGetItemIndex;
    end;
  end;
begin
  if FUpdating or FGlobalUpdating then
    Exit;

  if (csDestroying in FDataBinder.ComponentState) or (FDataBinder.FUpdateCount > 0) then
    Exit;

  if not Assigned(&Object) then
    Exit;

  if (PropertyName = '') and (BindType <> dbbtGrid) then
    Exit;

  p := nil;
  no := &Object;
  if not (BindType = dbbtGrid) then
  begin
    p := FindProperty(no, PropertyName);
    if not Assigned(p) then
      Exit;
  end;

  DoBeginUpdate;

  try
    if CheckDataSet and FDataBinder.Active then
    begin
      if (FDataLink.ReadOnly) and (AMode = dlmUpdateData) then
      begin
        DoEndUpdate;
        Exit;
      end;

      em := (DataLink.DataSet.State in [dsEdit, dsInsert]) and (AMode = dlmDataSetChanged);
      um := (DataLink.DataSet.State in [dsEdit, dsInsert]) and (AMode = dlmUpdateData) and FDirty;
      ai := GetActiveItemIndex;

      case BindType of
        dbbtSingleValue:
        begin
          elm := EditLinkMonitor;
          if Assigned(elm) and not elm.Active then
            elm.StartMonitoring;

          cvm := ControlValueMonitor;
          if Assigned(cvm) and not cvm.Active then
            cvm.StartMonitoring;

          if FieldName <> '' then
          begin
            f := DataLink.DataSet.FieldByName(FieldName);
            if Assigned(f) then
            begin
              if um then
              begin
                WritePropertyToField(no, p, f);
                FDirty := False;
              end
              else if em then
                ClearProperty(no, p)
              else
                WriteFieldToProperty(no, p, f);
            end;
          end
          else if (HTMLTemplate <> '') and (AMode <> dlmUpdateData) then
            WriteHTMLTemplateToProperty(no, p, HTMLTemplate);
        end;
        dbbtColumnList:
        begin
          case AMode of
            dlmDataSetChanged, dlmActiveChanged:
            begin
              k := TTMSFNCPersistence.GetPropInfoType(p);
              case k of
                tkClass:
                begin
                  o := GetObjectProp(no, p);
                  pcol := FindProperty(no, ColumnsPropertyName);
                  oc := nil;
                  if Assigned(pcol) then
                    oc := GetObjectProp(no, pcol);

                  if Assigned(oc) then
                  begin
                    its := nil;
                    if Assigned(o) and (o is TCollection) then
                    begin
                      its := o as TCollection;
                      if em then
                      begin
                        if ai > -1 then
                        begin
                          its.Insert(ai);
                          SetActiveItemIndex;
                        end;
                        DoEndUpdate;
                        Exit;
                      end;
                      its.Clear;
                    end;

                    if oc is TCollection then
                    begin
                      col := oc as TCollection;
                      col.Clear;

                      for I := 0 to DataLink.DataSet.FieldCount - 1 do
                      begin
                        colit := col.Add;
                        f := DataLink.DataSet.Fields[I];
                        if Assigned(f) then
                        begin
                          if ColumnsSubPropertyName <> '' then
                          begin
                            psub := FindProperty(colit, ColumnsSubPropertyName, -1, bftString);
                            if Assigned(psub) then
                              SetStrProp(colit, psub, f.FieldName);
                          end;
                        end;
                      end;

                      if Assigned(its) then
                      begin
                        DataLink.DataSet.DisableControls;
                        cb := DataLink.DataSet.GetBookmark;
                        DataLink.DataSet.First;
                        try
                          while not DataLink.DataSet.Eof do
                          begin
                            it := its.Add;
                            cit := it;
                            for I := 0 to DataLink.DataSet.FieldCount - 1 do
                            begin
                              f := DataLink.DataSet.Fields[I];
                              if Assigned(f) then
                              begin
                                for J := 0 to SubPropertyNames.Count - 1 do
                                begin
                                  itv := cit;
                                  {$IFNDEF WEBLIB}
                                  if f.DataType in [ftGraphic, ftBlob, ftTypedBinary] then
                                    psub := FindProperty(itv, SubPropertyNames[J].Value, -1, bftClass)
                                  else
                                  {$ENDIF}
                                    psub := FindProperty(itv, SubPropertyNames[J].Value);

                                  if Assigned(psub) then
                                    WriteFieldToProperty(itv, psub, f);
                                end;
                              end;
                            end;

                            DataLink.DataSet.Next;
                          end;
                        finally
                          DataLink.DataSet.GotoBookmark(cb);
                          DataLink.DataSet.FreeBookmark(cb);
                          DataLink.DataSet.EnableControls;
                        end;

                        SetActiveItemIndex;
                      end;
                    end;
                  end;
                end;
              end;
            end;
            dlmDataSetScrolled: SetActiveItemIndex;
            dlmRecordChanged:
            begin
              k := TTMSFNCPersistence.GetPropInfoType(p);
              case k of
                tkClass:
                begin
                  o := GetObjectProp(no, p);
                  pcol := FindProperty(no, ColumnsPropertyName);
                  oc := nil;
                  if Assigned(pcol) then
                    oc := GetObjectProp(no, pcol);

                  if Assigned(oc) then
                  begin
                    its := nil;
                    if Assigned(o) and (o is TCollection) then
                      its := o as TCollection;

                    if oc is TCollection then
                    begin
                      col := oc as TCollection;

                      for I := 0 to DataLink.DataSet.FieldCount - 1 do
                      begin
                        if (I >= 0) and (I <= col.Count - 1) then
                        begin
                          colit := col.Items[I];
                          f := DataLink.DataSet.Fields[I];
                          if Assigned(f) then
                          begin
                            if ColumnsSubPropertyName <> '' then
                            begin
                              psub := FindProperty(colit, ColumnsSubPropertyName, 0, bftString);
                              if Assigned(psub) then
                                SetStrProp(colit, psub, f.FieldName);
                            end;
                          end;
                        end;
                      end;

                      if Assigned(its) then
                      begin
                        try
                          if (ai >= 0) and (ai <= its.Count - 1) then
                          begin
                            it := its.Items[ai];
                            cit := it;
                            for I := 0 to DataLink.DataSet.FieldCount - 1 do
                            begin
                              f := DataLink.DataSet.Fields[I];
                              if Assigned(f) then
                              begin
                                for J := 0 to SubPropertyNames.Count - 1 do
                                begin
                                  itv := cit;
                                  {$IFNDEF WEBLIB}
                                  if f.DataType in [ftGraphic, ftBlob, ftTypedBinary] then
                                    psub := FindProperty(itv, SubPropertyNames[J].Value, I, bftClass)
                                  else
                                  {$ENDIF}
                                    psub := FindProperty(itv, SubPropertyNames[J].Value, I);

                                  if Assigned(psub) then
                                    WriteFieldToProperty(itv, psub, f);
                                end;
                              end;
                            end;
                          end;
                        finally
                        end;
                      end;
                    end;
                  end;
                end;
              end;
            end;
            dlmUpdateData: FDirty := False;
          end;
        end;
        dbbtGrid:
        begin
          case AMode of
            dlmDataSetChanged, dlmActiveChanged:
            begin
              if Supports(no, ITMSFNCDataBinderGrid, dbg) then
              begin
                if em then
                begin
                  if ai > -1 then
                  begin
                    dbg.DataInsertRow(ai);
                    SetActiveItemIndex;
                  end;
                  DoEndUpdate;
                  Exit;
                end;

                dbg.SetDataColumnCount(DataLink.DataSet.FieldCount);
                dbg.SetDataRowCount(GetRecordCount);

                for I := 0 to DataLink.DataSet.FieldCount - 1 do
                begin
                  f := DataLink.DataSet.Fields[I];
                  if Assigned(f) then
                    dbg.SetDataHeader(I, f.FieldName)
                end;

                DataLink.DataSet.DisableControls;
                cb := DataLink.DataSet.GetBookmark;
                DataLink.DataSet.First;
                try
                  L := 0;
                  while not DataLink.DataSet.Eof do
                  begin
                    for I := 0 to DataLink.DataSet.FieldCount - 1 do
                    begin
                      f := DataLink.DataSet.Fields[I];
                      if Assigned(f) then
                        dbg.SetDataValue(I, L, f.DisplayText);
                    end;

                    DataLink.DataSet.Next;
                    Inc(L);
                  end;
                finally
                  DataLink.DataSet.GotoBookmark(cb);
                  DataLink.DataSet.FreeBookmark(cb);
                  DataLink.DataSet.EnableControls;
                end;

                SetActiveItemIndex;
              end;
            end;
            dlmDataSetScrolled: SetActiveItemIndex;
            dlmRecordChanged:
            begin
              if Supports(no, ITMSFNCDataBinderGrid, dbg) then
              begin
                dbg.SetDataColumnCount(DataLink.DataSet.FieldCount);

                for I := 0 to DataLink.DataSet.FieldCount - 1 do
                begin
                  f := DataLink.DataSet.Fields[I];
                  if Assigned(f) then
                    dbg.SetDataHeader(I, f.FieldName)
                end;

                try
                  if (ai >= 0) and (ai <= dbg.GetDataRowCount - 1) then
                  begin
                    for I := 0 to DataLink.DataSet.FieldCount - 1 do
                    begin
                      f := DataLink.DataSet.Fields[I];
                      if Assigned(f) then
                        dbg.SetDataValue(I, ai, f.DisplayText);
                    end;
                  end;
                finally
                end;
              end;
            end;
            dlmUpdateData: FDirty := False;
          end;
        end;
        dbbtList:
        begin
          case AMode of
            dlmDataSetChanged, dlmActiveChanged:
            begin
              if (SubFieldNames.Count > 0) or (FieldName <> '') or (HTMLTemplate <> '') then
              begin
                k := TTMSFNCPersistence.GetPropInfoType(p);
                case k of
                  tkClass:
                  begin
                    o := GetObjectProp(no, p);
                    if Assigned(o) then
                    begin
                      its := nil;
                      sl := nil;
                      gls := nil;
                      gli := nil;

                      if o is TCollection then
                      begin
                        its := (o as TCollection);
                        if em then
                        begin
                          if ai > -1 then
                          begin
                            its.Insert(ai);
                            SetActiveItemIndex;
                          end;
                          DoEndUpdate;
                          Exit;
                        end;

                        its.Clear;
                      end
                      else if o is TStrings then
                      begin
                        sl := (o as TStrings);

                        if em then
                        begin
                          if ai > -1 then
                          begin
                            sl.Insert(ai, '');
                            SetActiveItemIndex;
                          end;
                          DoEndUpdate;
                          Exit;
                        end;

                        sl.Clear;
                      end
                      else if TTMSFNCPersistence.IsGenericList(o.ClassType, 'String') then
                      begin
                        gls := TTMSFNCStringList(o);

                        if em then
                        begin
                          if ai > -1 then
                          begin
                            gls.Insert(ai, '');
                            SetActiveItemIndex;
                          end;
                          DoEndUpdate;
                          Exit;
                        end;

                        gls.Clear;
                      end
                      else if TTMSFNCPersistence.IsGenericList(o.ClassType, 'Integer') then
                      begin
                        gli := TTMSFNCIntegerList(o);

                        if em then
                        begin
                          if ai > -1 then
                          begin
                            gli.Insert(ai, 0);
                            SetActiveItemIndex;
                          end;
                          DoEndUpdate;
                          Exit;
                        end;

                        gli.Clear;
                      end;

                      DataLink.DataSet.DisableControls;
                      cb := DataLink.DataSet.GetBookmark;
                      DataLink.DataSet.First;

                      try
                        while not DataLink.DataSet.Eof do
                        begin
                          if Assigned(its) then
                          begin
                            it := its.Add;
                            UpdateItem(it);
                          end
                          else if (SubFieldNames.Count > 0) or (FieldName <> '') or (HTMLTemplate <> '') then
                          begin
                            f := nil;
                            if (SubFieldNames.Count > 0) and (SubFieldNames[0].Value <> '') then
                              f := DataLink.DataSet.FieldByName(SubFieldNames[0].Value)
                            else if FieldName <> '' then
                              f := DataLink.DataSet.FieldByName(FieldName);

                            if Assigned(f) then
                            begin
                              if Assigned(sl) then
                                sl.Add(f.AsString)
                              else if Assigned(gls) then
                                gls.Add(f.AsString)
                              else if Assigned(gli) then
                                gli.Add(f.AsInteger);
                            end
                            else
                            begin
                              if (SubFieldNames.Count > 0) and (SubFieldNames[0].HTMLTemplate <> '') then
                                h := HTMLDBReplace(SubFieldNames[0].HTMLTemplate, DataLink.DataSet)
                              else
                                h := HTMLDBReplace(HTMLTemplate, DataLink.DataSet);

                              if Assigned(sl) then
                                sl.Add(h)
                              else if Assigned(gls) then
                                gls.Add(h);
                            end;
                          end;

                          DataLink.DataSet.Next;
                        end;

                      finally
                        DataLink.DataSet.GotoBookmark(cb);
                        DataLink.DataSet.FreeBookmark(cb);
                        DataLink.DataSet.EnableControls;
                      end;

                      SetActiveItemIndex;
                    end;
                  end;
                end;
              end;
            end;
            dlmDataSetScrolled: SetActiveItemIndex;
            dlmRecordChanged:
            begin
              if (SubFieldNames.Count > 0) or (FieldName <> '') or (HTMLTemplate <> '') then
              begin
                k := TTMSFNCPersistence.GetPropInfoType(p);
                case k of
                  tkClass:
                  begin
                    o := GetObjectProp(no, p);
                    if Assigned(o) then
                    begin
                      its := nil;
                      sl := nil;
                      gls := nil;
                      gli := nil;

                      if o is TCollection then
                        its := (o as TCollection)
                      else if o is TStrings then
                        sl := (o as TStrings)
                      else if TTMSFNCPersistence.IsGenericList(o.ClassType, 'String') then
                        gls := TTMSFNCStringList(o)
                      else if TTMSFNCPersistence.IsGenericList(o.ClassType, 'Integer') then
                        gli := TTMSFNCIntegerList(o);

                      try
                        if Assigned(its) then
                        begin
                          if (ai >= 0) and (ai <= its.Count - 1) then
                          begin
                            it := its.Items[ai];
                            UpdateItem(it);
                          end;
                        end
                        else if (SubFieldNames.Count > 0) or (FieldName <> '') or (HTMLTemplate <> '') then
                        begin
                          if (SubFieldNames.Count > 0) and (SubFieldNames[0].Value <> '') then
                            f := DataLink.DataSet.FieldByName(SubFieldNames[0].Value)
                          else
                            f := DataLink.DataSet.FieldByName(FieldName);

                          if Assigned(f) then
                          begin
                            if Assigned(sl) then
                            begin
                              if (ai >= 0) and (ai <= sl.Count - 1) then
                                sl[ai] := f.AsString;
                            end
                            else if Assigned(gls) then
                            begin
                              if (ai >= 0) and (ai <= gls.Count - 1) then
                                gls[ai] := f.AsString;
                            end
                            else if Assigned(gli) then
                            begin
                              if (ai >= 0) and (ai <= gli.Count - 1) then
                                gli[ai] := f.AsInteger;
                            end;
                          end
                          else
                          begin
                            h := HTMLDBReplace(HTMLTemplate, DataLink.DataSet);
                            if Assigned(sl) then
                            begin
                              if (ai >= 0) and (ai <= sl.Count - 1) then
                                sl[ai] := h;
                            end
                            else if Assigned(gls) then
                            begin
                              if (ai >= 0) and (ai <= gls.Count - 1) then
                                gls[ai] := h;
                            end;
                          end;
                        end;
                      finally
                      end;
                    end;
                  end;
                end;
              end;
            end;
            dlmUpdateData: FDirty := False;
          end;
        end;
      end;
    end
    else
    begin
      case BindType of
        dbbtSingleValue: ClearProperty(no, p);
        dbbtColumnList:
        begin
          k := TTMSFNCPersistence.GetPropInfoType(p);
          case k of
            tkClass:
            begin
              o := GetObjectProp(no, p);
              pcol := FindProperty(no, ColumnsPropertyName);
              oc := nil;
              if Assigned(pcol) then
                oc := GetObjectProp(no, pcol);

              if Assigned(o) and (o is TCollection) then
              begin
                its := o as TCollection;
                its.Clear;
              end;

              if Assigned(oc) and (oc is TCollection) then
              begin
                col := oc as TCollection;
                col.Clear;
              end;
            end;
          end;
        end;
        dbbtGrid:
        begin
          if Supports(no, ITMSFNCDataBinderGrid, dbg) then
            dbg.ClearData;
        end;
        dbbtList:
        begin
          k := TTMSFNCPersistence.GetPropInfoType(p);
          case k of
            tkClass:
            begin
              o := GetObjectProp(no, p);
              if Assigned(o) then
              begin
                if o is TCollection then
                begin
                  col := (o as TCollection);
                  col.Clear;
                end
                else if o is TStrings then
                begin
                  sl := (o as TStrings);
                  sl.Clear;
                end
                else if TTMSFNCPersistence.IsGenericList(o.ClassType, 'String') then
                begin
                  gls := TTMSFNCStringList(o);
                  gls.Clear;
                end
                else if TTMSFNCPersistence.IsGenericList(o.ClassType, 'Integer') then
                begin
                  gli := TTMSFNCIntegerList(o);
                  gli.Clear;
                end;
              end;
            end;
          end;
        end;
      end;
    end;

  finally
    DoEndUpdate;
  end;
end;

procedure TTMSFNCDataBinderItem.WriteHTMLTemplateToProperty(AObject: TObject;
  APropInfo: TTMSFNCPropertyInfo; AHTMLTemplate: string);
var
  a: Boolean;
  pName: string;
  k: TTypeKind;
  p: TTMSFNCPropertyInfo;
  o: TObject;
  s: string;
  t: string;
begin
  if (AHTMLTemplate = '') or not Assigned(AObject) or not Assigned(APropInfo) then
    Exit;

  o := AObject;
  p := APropInfo;
  pName := TTMSFNCPersistence.GetPropInfoName(p);
  k := TTMSFNCPersistence.GetPropInfoType(p);

  a := True;
  t := AHTMLTemplate;
  DoBeforeWriteHTMLTemplateToProperty(o, Self, p, pName, k, t, a);
  if a then
  begin
    case k of
      {$IFNDEF WEBLIB}tkWChar, tkLString, tkUString,{$ENDIF}tkChar, tkString{$IFDEF LCLLIB},tkAString{$ENDIF}:
      begin
        s := HTMLDBReplace(t, DataLink.DataSet);
        if not TTMSFNCPersistence.IsReadOnly(p) then
          SetStrProp(o, p, s);
      end;
    end;

    DoAfterWriteHTMLTemplateToProperty(o, Self, p, pName, k, t);
  end;
end;

function TTMSFNCDataBinderItem.TryGetObjectStringValue(AObject: TObject; out AValue: string): Boolean;
var
  p: TTMSFNCPropertyInfo;
begin
  Result := False;
  AValue := '';

  if not Assigned(AObject) then
    Exit;

  p := InternalFindProperty(AObject, 'Text', bftString);
  if Assigned(p) and not TTMSFNCPersistence.IsWriteOnly(p) then
  begin
    AValue := GetStrProp(AObject, p);
    Result := True;
    Exit;
  end;

  p := InternalFindProperty(AObject, 'AsString', bftString);
  if Assigned(p) and not TTMSFNCPersistence.IsWriteOnly(p) then
  begin
    AValue := GetStrProp(AObject, p);
    Result := True;
  end;
end;

function TTMSFNCDataBinderItem.TrySetObjectStringValue(AObject: TObject; const AValue: string): Boolean;
var
  p: TTMSFNCPropertyInfo;
begin
  Result := False;

  if not Assigned(AObject) then
    Exit;

  p := InternalFindProperty(AObject, 'Text', bftString);
  if Assigned(p) and not TTMSFNCPersistence.IsReadOnly(p) then
  begin
    SetStrProp(AObject, p, AValue);
    Result := True;
    Exit;
  end;

  p := InternalFindProperty(AObject, 'AsString', bftString);
  if Assigned(p) and not TTMSFNCPersistence.IsReadOnly(p) then
  begin
    SetStrProp(AObject, p, AValue);
    Result := True;
  end;
end;

procedure TTMSFNCDataBinderItem.WriteFieldToProperty(AObject: TObject;
  APropInfo: TTMSFNCPropertyInfo; AField: TField);
var
  a: Boolean;
  pName, cn: string;
  k: TTypeKind;
  p: TTMSFNCPropertyInfo;
  o: TObject;
  i: Integer;
  s: string;
  dt: TDateTime;
  ui: LongWord;
  ob: TObject;
  bt: TTMSFNCBitmap;
  ms: TMemoryStream;
  {$IFNDEF WEBLIB}
  v: Variant;
  {$ENDIF}
  sl: TStringList;
  useDisplayText: Boolean;
begin
  if not Assigned(AField) or not Assigned(AObject) or not Assigned(APropInfo) then
    Exit;

  o := AObject;
  p := APropInfo;
  pName := TTMSFNCPersistence.GetPropInfoName(p);
  k := TTMSFNCPersistence.GetPropInfoType(p);

  a := True;
  DoBeforeWriteFieldToProperty(o, Self, p, pName, k, AField, a);
  if not a then
    Exit;

  try
    case k of
      tkClass:
      begin
        cn := TTMSFNCPersistence.GetPropInfoTypeName(p);
        ob := GetObjectProp(AObject, pName);

        if not Assigned(ob) then
          Exit;

        if ob is TStrings then
        begin
          case AField.DataType of
            ftString, ftWideString, ftFixedChar, ftFixedWideChar:
              if Assigned(AField.OnGetText) then
                (ob as TStrings).Text := AField.DisplayText
              else
                (ob as TStrings).Text := AField.AsString;
            ftMemo, ftFmtMemo, ftWideMemo, ftOraClob:
              if Assigned(AField.OnGetText) then
                (ob as TStrings).Text := AField.DisplayText
              else
                (ob as TStrings).Text := AField.AsString;
            ftBlob, ftOraBlob:
              begin
                {$IFNDEF WEBLIB}
                ms := TMemoryStream.Create;
                try
                  (AField as TBlobField).SaveToStream(ms);
                  ms.Position := 0;
                  (ob as TStrings).LoadFromStream(ms);
                finally
                  ms.Free;
                end;
                {$ELSE}
                (ob as TStrings).Text := AField.AsString;
                {$ENDIF}
              end;
            else
              (ob as TStrings).Text := AField.DisplayText;
          end;
        end
        {$IFNDEF WEBLIB}
        else if AField.DataType in [ftGraphic, ftBlob, ftTypedBinary, ftOraBlob, ftParadoxOle, ftDBaseOle] then
        begin
          if (cn = 'TBitmap') or (cn = 'TPicture') or (cn = 'TTMSFNCBitmap') then
          begin
            bt := TTMSFNCBitmap.Create;
            try
              TTMSFNCDataBinder.BlobFieldToBitmap(AField, bt);
              if ob is TPersistent then
                (ob as TPersistent).Assign(bt);
            finally
              bt.Free;
            end;
          end
          else if (cn = 'TStream') or (cn = 'TMemoryStream') then
          begin
            if ob is TStream then
            begin
              ms := TMemoryStream.Create;
              try
                (AField as TBlobField).SaveToStream(ms);
                ms.Position := 0;
                (ob as TStream).Size := 0;
                (ob as TStream).CopyFrom(ms, ms.Size);
                (ob as TStream).Position := 0;
              finally
                ms.Free;
              end;
            end;
          end;
        end
        {$ENDIF}
        else if TTMSFNCPersistence.IsGenericList(ob.ClassType, 'String') then
        begin
          case AField.DataType of
            ftString, ftWideString, ftMemo, ftWideMemo:
              begin
                TTMSFNCStringList(ob).Clear;
                sl := TStringList.Create;
                try
                  if Assigned(AField.OnGetText) then
                    sl.Text := AField.DisplayText
                  else
                    sl.Text := AField.AsString;
                  for i := 0 to sl.Count - 1 do
                    TTMSFNCStringList(ob).Add(sl[i]);
                finally
                  sl.Free;
                end;
              end;
          end;
        end
        else if ob is TPersistent then
        begin
          case AField.DataType of
            ftString, ftWideString, ftMemo, ftWideMemo, ftFixedChar:
              if Assigned(AField.OnGetText) then
                TrySetObjectStringValue(ob, AField.DisplayText)
              else
                TrySetObjectStringValue(ob, AField.AsString);
            else
              TrySetObjectStringValue(ob, AField.DisplayText);
          end;
        end;
      end;

      tkInteger:
      begin
        if not TTMSFNCPersistence.IsReadOnly(p) then
        begin
          useDisplayText := Assigned(AField.OnGetText) and
            (AField.DataType in [ftString, ftWideString, ftFixedChar, ftFixedWideChar]);

          case AField.DataType of
            ftSmallint, ftInteger, ftWord:
              SetOrdProp(o, p, AField.AsInteger);
            ftAutoInc:
              SetOrdProp(o, p, AField.AsInteger);
            {$IFNDEF WEBLIB}
            ftLargeint:
              SetInt64Prop(o, p, AField.AsLargeInt);
            {$ENDIF}
            {$IFNDEF LCLLIB}
            ftLongWord:
              begin
                {$IFNDEF WEBLIB}
                ui := AField.AsLongWord;
                SetOrdProp(o, p, Integer(ui));
                {$ELSE}
                SetOrdProp(o, p, AField.AsInteger);
                {$ENDIF}
              end;
            ftShortint:
              SetOrdProp(o, p, AField.AsInteger);
            ftByte:
              SetOrdProp(o, p, AField.AsInteger);
            {$ENDIF}
            ftBoolean:
              SetOrdProp(o, p, Ord(AField.AsBoolean));
            ftFloat, ftCurrency, ftBCD, ftFMTBcd{$IFNDEF LCLLIB}, ftExtended, ftSingle{$ENDIF}:
              SetOrdProp(o, p, Round(AField.AsFloat));
            ftString, ftWideString, ftFixedChar, ftFixedWideChar:
              if useDisplayText then
                SetOrdProp(o, p, StrToIntDef(AField.DisplayText, 0))
              else
                SetOrdProp(o, p, StrToIntDef(AField.AsString, 0));
            {$IFNDEF WEBLIB}
            ftVariant:
              begin
                v := AField.AsVariant;
                if not VarIsNull(v) then
                  SetOrdProp(o, p, v);
              end;
            {$ENDIF}
            else
              SetOrdProp(o, p, AField.AsInteger);
          end;
        end;
      end;

      {$IFNDEF WEBLIB}tkWChar, tkLString, tkUString,{$ENDIF}tkChar, tkString{$IFDEF LCLLIB},tkAString{$ENDIF}:
      begin
        if not TTMSFNCPersistence.IsReadOnly(p) then
        begin
          useDisplayText := Assigned(AField.OnGetText);

          case AField.DataType of
            ftString, ftWideString, ftFixedChar, ftFixedWideChar:
              if useDisplayText then
                SetStrProp(o, p, AField.DisplayText)
              else
                SetStrProp(o, p, AField.AsString);
            ftMemo, ftFmtMemo, ftWideMemo:
              if Assigned(AField.OnGetText) then
                SetStrProp(o, p, AField.DisplayText)
              else
                SetStrProp(o, p, AField.AsString);
            ftOraClob:
              SetStrProp(o, p, AField.AsString);
            ftGuid:
              if useDisplayText then
                SetStrProp(o, p, AField.DisplayText)
              else
                SetStrProp(o, p, AField.AsString);
            {$IFNDEF WEBLIB}
            ftVariant:
              begin
                v := AField.AsVariant;
                if not VarIsNull(v) then
                begin
                  if useDisplayText then
                    SetStrProp(o, p, AField.DisplayText)
                  else
                    SetStrProp(o, p, VarToStr(v));
                end
                else
                  SetStrProp(o, p, '');
              end;
            {$ENDIF}
            else
              SetStrProp(o, p, AField.DisplayText);
          end;
        end;
      end;

      tkEnumeration:
      begin
        if TTMSFNCPersistence.GetPropInfoDataTypeInfo(p) = TypeInfo(Boolean) then
        begin
          if not TTMSFNCPersistence.IsReadOnly(p) then
          begin
            case AField.DataType of
              ftBoolean:
                SetOrdProp(o, p, Ord(AField.AsBoolean));
              ftString, ftWideString, ftFixedChar:
                begin
                  if Assigned(AField.OnGetText) then
                    s := Trim(UpperCase(AField.DisplayText))
                  else
                    s := Trim(UpperCase(AField.AsString));
                  if BooleanStringValue <> '' then
                    SetOrdProp(o, p, Ord(s = UpperCase(BooleanStringValue)))
                  else
                    SetOrdProp(o, p, Ord((s = 'TRUE') or (s = 'T') or (s = 'YES') or (s = 'Y') or (s = '1')));
                end;
              ftInteger, ftSmallint, ftWord{$IFNDEF LCLLIB}, ftShortint, ftByte{$ENDIF}:
                SetOrdProp(o, p, Ord(AField.AsInteger <> 0));
              {$IFNDEF LCLLIB}
              ftLongWord:
                begin
                  {$IFNDEF WEBLIB}
                  ui := AField.AsLongWord;
                  SetOrdProp(o, p, Ord(ui <> 0));
                  {$ELSE}
                  SetOrdProp(o, p, Ord(AField.AsInteger <> 0));
                  {$ENDIF}
                end;
              {$ENDIF}
              {$IFNDEF WEBLIB}
              ftVariant:
                begin
                  v := AField.AsVariant;
                  if not VarIsNull(v) then
                    SetOrdProp(o, p, Ord(Boolean(v)));
                end;
              {$ENDIF}
              else
                SetOrdProp(o, p, Ord(AField.AsBoolean));
            end;
          end;
        end
        else
        begin
          if not TTMSFNCPersistence.IsReadOnly(p) then
          begin
            case AField.DataType of
              ftString, ftWideString, ftFixedChar:
                begin
                  if Assigned(AField.OnGetText) then
                    s := Trim(AField.DisplayText)
                  else
                    s := Trim(AField.AsString);
                  i := GetEnumValue({$IFDEF WEBLIB}TTypeInfoEnum{$ENDIF}(TTMSFNCPersistence.GetPropInfoDataTypeInfo(p)), s);
                  if i >= 0 then
                    SetOrdProp(o, p, i)
                  else
                    SetOrdProp(o, p, 0);
                end;
              ftInteger, ftSmallint, ftWord{$IFNDEF LCLLIB}, ftShortint, ftByte{$ENDIF}:
                SetOrdProp(o, p, AField.AsInteger);
              {$IFNDEF LCLLIB}
              ftLongWord:
                begin
                  {$IFNDEF WEBLIB}
                  ui := AField.AsLongWord;
                  if ui <= LongWord(High(Integer)) then
                    SetOrdProp(o, p, Integer(ui))
                  else
                    SetOrdProp(o, p, 0);
                  {$ELSE}
                  SetOrdProp(o, p, AField.AsInteger);
                  {$ENDIF}
                end;
              {$ENDIF}
              else
                SetOrdProp(o, p, AField.AsInteger);
            end;
          end;
        end;
      end;

      {$IFDEF LCLWEBLIB}
      tkBool:
      begin
        if not TTMSFNCPersistence.IsReadOnly(p) then
        begin
          case AField.DataType of
            ftBoolean:
              SetOrdProp(o, p, Ord(AField.AsBoolean));
            ftString, ftWideString:
              begin
                if Assigned(AField.OnGetText) then
                  s := Trim(UpperCase(AField.DisplayText))
                else
                  s := Trim(UpperCase(AField.AsString));
                SetOrdProp(o, p, Ord((s = 'TRUE') or (s = 'T') or (s = 'YES') or (s = 'Y') or (s = '1')));
              end;
            ftInteger, ftSmallint, ftWord:
              SetOrdProp(o, p, Ord(AField.AsInteger <> 0));
            {$IFNDEF LCLLIB}
            ftLongWord:
              begin
                {$IFNDEF WEBLIB}
                ui := AField.AsLongWord;
                SetOrdProp(o, p, Ord(ui <> 0));
                {$ELSE}
                SetOrdProp(o, p, Ord(AField.AsInteger <> 0));
                {$ENDIF}
              end;
            {$ENDIF}
            else
              SetOrdProp(o, p, Ord(AField.AsBoolean));
          end;
        end;
      end;
      {$ENDIF}

      tkFloat:
      begin
        if not TTMSFNCPersistence.IsReadOnly(p) then
        begin
          cn := TTMSFNCPersistence.GetPropInfoTypeName(p);
          if (CompareText(cn, 'TDateTime') = 0) or
             (CompareText(cn, 'TDate') = 0) or
             (CompareText(cn, 'TTime') = 0) then
          begin
            case AField.DataType of
              ftDate:
                SetFloatProp(o, p, AField.AsDateTime);
              ftTime:
                SetFloatProp(o, p, AField.AsDateTime);
              ftDateTime, ftTimeStamp:
                SetFloatProp(o, p, AField.AsDateTime);
              ftString, ftWideString:
                begin
                  if Assigned(AField.OnGetText) then
                    dt := StrToDateTimeDef(AField.DisplayText, 0)
                  else
                    dt := StrToDateTimeDef(AField.AsString, 0);
                  SetFloatProp(o, p, dt);
                end;
              ftFloat{$IFNDEF LCLLIB}, ftExtended{$ENDIF}:
                SetFloatProp(o, p, AField.AsFloat);
              else
                SetFloatProp(o, p, AField.AsFloat);
            end;
          end
          else
          begin
            case AField.DataType of
              ftFloat, ftCurrency, ftBCD, ftFMTBcd{$IFNDEF LCLLIB}, ftExtended, ftSingle{$ENDIF}:
                SetFloatProp(o, p, AField.AsFloat);
              ftInteger, ftSmallint, ftWord:
                SetFloatProp(o, p, AField.AsInteger);
              {$IFNDEF LCLLIB}
              ftLongWord:
                begin
                  {$IFNDEF WEBLIB}
                  ui := AField.AsLongWord;
                  SetFloatProp(o, p, ui);
                  {$ELSE}
                  SetFloatProp(o, p, AField.AsFloat);
                  {$ENDIF}
                end;
              {$ENDIF}
              ftLargeint:
                SetFloatProp(o, p, AField.AsLargeInt);
              else
                SetFloatProp(o, p, AField.AsFloat);
            end;
          end;
        end;
      end;

      {$IFNDEF WEBLIB}
      tkInt64:
      begin
        if not TTMSFNCPersistence.IsReadOnly(p) then
        begin
          case AField.DataType of
            ftLargeint:
              SetInt64Prop(o, p, AField.AsLargeInt);
            ftInteger, ftSmallint, ftWord, ftAutoInc:
              SetInt64Prop(o, p, AField.AsInteger);
            {$IFNDEF LCLLIB}
            ftLongWord:
              begin
                ui := AField.AsLongWord;
                SetInt64Prop(o, p, ui);
              end;
            {$ENDIF}
            ftFloat, ftCurrency:
              SetInt64Prop(o, p, Round(AField.AsFloat));
            else
              SetInt64Prop(o, p, AField.AsLargeInt);
          end;
        end;
      end;
      {$ENDIF}

      tkSet:
      begin
        if not TTMSFNCPersistence.IsReadOnly(p) then
        begin
          case AField.DataType of
            ftInteger, ftSmallint, ftWord:
              SetOrdProp(o, p, AField.AsInteger);
            {$IFNDEF LCLLIB}
            ftLongWord:
              begin
                {$IFNDEF WEBLIB}
                ui := AField.AsLongWord;
                if ui <= Longword(High(Integer)) then
                  SetOrdProp(o, p, Integer(ui))
                else
                  SetOrdProp(o, p, 0);
                {$ELSE}
                SetOrdProp(o, p, AField.AsInteger);
                {$ENDIF}
              end;
            {$ENDIF}
            ftString, ftWideString:
              begin
                {$IFNDEF WEBLIB}
                if Assigned(AField.OnGetText) then
                  i := StringToSet(TTMSFNCPersistence.GetPropInfoDataTypeInfo(p), AField.DisplayText)
                else
                  i := StringToSet(TTMSFNCPersistence.GetPropInfoDataTypeInfo(p), AField.AsString);
                SetOrdProp(o, p, i);
                {$ENDIF}
              end;
            else
              SetOrdProp(o, p, AField.AsInteger);
          end;
        end;
      end;
    end;

    DoAfterWriteFieldToProperty(o, Self, p, pName, k, AField);
  except
    on E: Exception do
    begin
    end;
  end;
end;

procedure TTMSFNCDataBinderItem.WritePropertyToField(AObject: TObject;
  APropInfo: TTMSFNCPropertyInfo; AField: TField);
var
  a: Boolean;
  pName, cn: string;
  k: TTypeKind;
  p: TTMSFNCPropertyInfo;
  o: TObject;
  b: Boolean;
  ob: TObject;
  bt: TTMSFNCBitmap;
  ms: TMemoryStream;
  i: Integer;
  s: string;
  d: Double;
  dt: TDateTime;
  ii: Int64;
  ui: LongWord;
  useText: Boolean;
begin
  if not Assigned(AField) or not Assigned(AObject) or not Assigned(APropInfo) then
    Exit;

  if not AField.CanModify then
    Exit;

  o := AObject;
  p := APropInfo;
  pName := TTMSFNCPersistence.GetPropInfoName(p);
  k := TTMSFNCPersistence.GetPropInfoType(p);

  a := True;
  DoBeforeWritePropertyToField(o, Self, p, pName, k, AField, a);
  if not a then
    Exit;

  try
    case k of
      tkClass:
      begin
        cn := TTMSFNCPersistence.GetPropInfoTypeName(p);
        ob := GetObjectProp(AObject, pName);

        if not Assigned(ob) then
          Exit;

        if ob is TStrings then
        begin
          useText := Assigned(AField.OnSetText);
          case AField.DataType of
            ftString, ftWideString, ftFixedChar, ftFixedWideChar:
              begin
                if (ob as TStrings).Count > 0 then
                  s := (ob as TStrings)[0]
                else
                  s := '';
                if useText then
                  AField.Text := s
                else
                  AField.AsString := s;
              end;
            ftMemo, ftFmtMemo, ftWideMemo, ftOraClob:
              if useText then
                AField.Text := (ob as TStrings).Text
              else
                AField.AsString := (ob as TStrings).Text;
            {$IFNDEF WEBLIB}
            ftBlob, ftOraBlob:
              begin
                ms := TMemoryStream.Create;
                try
                  (ob as TStrings).SaveToStream(ms);
                  ms.Position := 0;
                  (AField as TBlobField).LoadFromStream(ms);
                finally
                  ms.Free;
                end;
              end;
            {$ENDIF}
            else
              if useText then
                AField.Text := (ob as TStrings).Text
              else
                AField.AsString := (ob as TStrings).Text;
          end;
        end
        {$IFNDEF WEBLIB}
        else if AField.DataType in [ftGraphic, ftBlob, ftTypedBinary, ftOraBlob] then
        begin
          if (cn = 'TBitmap') or (cn = 'TPicture') or (cn = 'TTMSFNCBitmap') then
          begin
            if ob is TPersistent then
            begin
              bt := TTMSFNCBitmap.Create;
              try
                bt.Assign(ob as TPersistent);
                TTMSFNCDataBinder.BitmapToBlobField(AField, bt);
              finally
                bt.Free;
              end;
            end;
          end
          else if (cn = 'TStream') or (cn = 'TMemoryStream') then
          begin
            if ob is TStream then
            begin
              ms := TMemoryStream.Create;
              try
                (ob as TStream).Position := 0;
                ms.CopyFrom(ob as TStream, (ob as TStream).Size);
                ms.Position := 0;
                (AField as TBlobField).LoadFromStream(ms);
              finally
                ms.Free;
              end;
            end;
          end;
        end
        {$ENDIF}
        else if TTMSFNCPersistence.IsGenericList(ob.ClassType, 'String') then
        begin
          useText := Assigned(AField.OnSetText);
          case AField.DataType of
            ftString, ftWideString:
              begin
                s := '';
                for i := 0 to TTMSFNCStringList(ob).Count - 1 do
                begin
                  if i > 0 then s := s + ',';
                  s := s + TTMSFNCStringList(ob)[i];
                end;
                if useText then
                  AField.Text := s
                else
                  AField.AsString := s;
              end;
            ftMemo, ftWideMemo:
              begin
                s := '';
                for i := 0 to TTMSFNCStringList(ob).Count - 1 do
                begin
                  if i > 0 then s := s + #13#10;
                  s := s + TTMSFNCStringList(ob)[i];
                end;
                if useText then
                  AField.Text := s
                else
                  AField.AsString := s;
              end;
          end;
        end
        else if ob is TPersistent then
        begin
          if TryGetObjectStringValue(ob, s) then
          begin
            useText := Assigned(AField.OnSetText);
            case AField.DataType of
              ftString, ftWideString, ftFixedChar:
                if useText then
                  AField.Text := s
                else
                  AField.AsString := s;
              ftMemo, ftWideMemo:
                AField.AsString := s;
              else
                if s <> '' then
                begin
                  if useText then
                    AField.Text := s
                  else
                    AField.AsString := s;
                end;
            end;
          end;
        end;
      end;

      tkInteger:
      begin
        if not TTMSFNCPersistence.IsWriteOnly(p) then
        begin
          i := GetOrdProp(o, p);
          useText := Assigned(AField.OnSetText);

          case AField.DataType of
            ftInteger, ftSmallint, ftWord, ftAutoInc:
              if useText then
                AField.Text := IntToStr(i)
              else
                AField.AsInteger := i;
            ftLargeint:
              if useText then
                AField.Text := IntToStr(i)
              else
                AField.AsLargeInt := i;
            {$IFNDEF LCLLIB}
            ftLongWord:
              begin
                {$IFNDEF WEBLIB}
                ui := LongWord(i);
                if useText then
                  AField.Text := IntToStr(ui)
                else
                  AField.AsLongWord := ui;
                {$ELSE}
                if useText then
                  AField.Text := IntToStr(i)
                else
                  AField.AsInteger := i;
                {$ENDIF}
              end;
            {$ENDIF}
            ftFloat, ftCurrency, ftBCD, ftFMTBcd:
              if useText then
                AField.Text := IntToStr(i)
              else
                AField.AsFloat := i;
            ftBoolean:
              if useText then
                AField.Text := BoolToStr(i <> 0, True)
              else
                AField.AsBoolean := i <> 0;
            ftString, ftWideString:
              if useText then
                AField.Text := IntToStr(i)
              else
                AField.AsString := IntToStr(i);
            else
              if useText then
                AField.Text := IntToStr(i)
              else
                AField.AsInteger := i;
          end;
        end;
      end;

      {$IFNDEF WEBLIB}tkWChar, tkLString, tkUString,{$ENDIF}tkChar, tkString{$IFDEF LCLLIB},tkAString{$ENDIF}:
      begin
        if not TTMSFNCPersistence.IsWriteOnly(p) then
        begin
          s := GetStrProp(o, p);
          useText := Assigned(AField.OnSetText);

          case AField.DataType of
            ftString, ftWideString, ftFixedChar, ftFixedWideChar:
              if useText then
                AField.Text := s
              else
                AField.AsString := s;
            ftMemo, ftFmtMemo, ftWideMemo:
              if useText then
                AField.Text := s
              else
                AField.AsString := s;
            ftGuid:
              if useText then
                AField.Text := s
              else
                AField.AsString := s;
            ftInteger, ftSmallint, ftWord:
              if useText then
                AField.Text := s
              else
                AField.AsInteger := StrToIntDef(s, 0);
            {$IFNDEF LCLLIB}
            ftLongWord:
              begin
                {$IFNDEF WEBLIB}
                if useText then
                  AField.Text := s
                else
                begin
                  ui := StrToInt64Def(s, 0);
                  AField.AsLongWord := ui;
                end;
                {$ELSE}
                if useText then
                  AField.Text := s
                else
                  AField.AsInteger := StrToIntDef(s, 0);
                {$ENDIF}
              end;
            {$ENDIF}
            ftFloat, ftCurrency:
              if useText then
                AField.Text := s
              else
                AField.AsFloat := StrToFloatDef(s, 0);
            ftBoolean:
              if useText then
                AField.Text := s
              else
                AField.AsBoolean := (UpperCase(s) = 'TRUE') or (s = '1');
            else
              if useText then
                AField.Text := s
              else
                AField.AsString := s;
          end;
        end;
      end;

      tkEnumeration:
      begin
        if TTMSFNCPersistence.GetPropInfoDataTypeInfo(p) = TypeInfo(Boolean) then
        begin
          if not TTMSFNCPersistence.IsWriteOnly(p) then
          begin
            b := Boolean(GetOrdProp(o, p));
            useText := Assigned(AField.OnSetText);

            case AField.DataType of
              ftBoolean:
                if useText then
                  AField.Text := BoolToStr(b, True)
                else
                  AField.AsBoolean := b;
              ftString, ftWideString:
                begin
                  if BooleanStringValue <> '' then
                  begin
                    if b then
                      s := BooleanStringValue
                    else
                      s := '';
                  end
                  else
                    s := BoolToStr(b, True);

                  if useText then
                    AField.Text := s
                  else
                    AField.AsString := s;
                end;
              ftInteger, ftSmallint, ftWord:
                if useText then
                  AField.Text := IntToStr(Ord(b))
                else
                  AField.AsInteger := Ord(b);
              {$IFNDEF LCLLIB}
              ftLongWord:
                begin
                  {$IFNDEF WEBLIB}
                  if useText then
                    AField.Text := IntToStr(Ord(b))
                  else
                    AField.AsLongWord := Ord(b);
                  {$ELSE}
                  if useText then
                    AField.Text := IntToStr(Ord(b))
                  else
                    AField.AsInteger := Ord(b);
                  {$ENDIF}
                end;
              {$ENDIF}
              else
                if useText then
                  AField.Text := BoolToStr(b, True)
                else
                  AField.AsBoolean := b;
            end;
          end;
        end
        else
        begin
          if not TTMSFNCPersistence.IsWriteOnly(p) then
          begin
            i := GetOrdProp(o, p);
            useText := Assigned(AField.OnSetText);

            case AField.DataType of
              ftString, ftWideString:
                begin
                  s := GetEnumName({$IFDEF WEBLIB}TTypeInfoEnum{$ENDIF}(TTMSFNCPersistence.GetPropInfoDataTypeInfo(p)), i);
                  if useText then
                    AField.Text := s
                  else
                    AField.AsString := s;
                end;
              {$IFNDEF LCLLIB}
              ftLongWord:
                begin
                  {$IFNDEF WEBLIB}
                  if useText then
                    AField.Text := IntToStr(i)
                  else
                    AField.AsLongWord := i;
                  {$ELSE}
                  if useText then
                    AField.Text := IntToStr(i)
                  else
                    AField.AsInteger := i;
                  {$ENDIF}
                end;
              {$ENDIF}
              else
                if useText then
                  AField.Text := IntToStr(i)
                else
                  AField.AsInteger := i;
            end;
          end;
        end;
      end;

      {$IFDEF LCLWEBLIB}
      tkBool:
      begin
        if not TTMSFNCPersistence.IsWriteOnly(p) then
        begin
          b := Boolean(GetOrdProp(o, p));
          useText := Assigned(AField.OnSetText);

          case AField.DataType of
            ftBoolean:
              if useText then
                AField.Text := BoolToStr(b, True)
              else
                AField.AsBoolean := b;
            ftString, ftWideString:
              if useText then
                AField.Text := BoolToStr(b, True)
              else
                AField.AsString := BoolToStr(b, True);
            ftInteger, ftSmallint, ftWord:
              if useText then
                AField.Text := IntToStr(Ord(b))
              else
                AField.AsInteger := Ord(b);
            {$IFNDEF LCLLIB}
            ftLongWord:
              begin
                {$IFNDEF WEBLIB}
                if useText then
                  AField.Text := IntToStr(Ord(b))
                else
                  AField.AsLongWord := Ord(b);
                {$ELSE}
                if useText then
                  AField.Text := IntToStr(Ord(b))
                else
                  AField.AsInteger := Ord(b);
                {$ENDIF}
              end;
            {$ENDIF}
            else
              if useText then
                AField.Text := BoolToStr(b, True)
              else
                AField.AsBoolean := b;
          end;
        end;
      end;
      {$ENDIF}

      tkFloat:
      begin
        if not TTMSFNCPersistence.IsWriteOnly(p) then
        begin
          d := GetFloatProp(o, p);
          useText := Assigned(AField.OnSetText);

          cn := TTMSFNCPersistence.GetPropInfoTypeName(p);
          if (CompareText(cn, 'TDateTime') = 0) or
             (CompareText(cn, 'TDate') = 0) or
             (CompareText(cn, 'TTime') = 0) then
          begin
            dt := d;
            case AField.DataType of
              ftDate, ftDateTime:
                if useText then
                  AField.Text := DateTimeToStr(dt)
                else
                  AField.AsDateTime := dt;
              ftTime:
                if useText then
                  AField.Text := TimeToStr(Frac(dt))
                else
                  AField.AsDateTime := Frac(dt);
              ftTimeStamp:
                if useText then
                  AField.Text := DateTimeToStr(dt)
                else
                  AField.AsDateTime := dt;
              ftString, ftWideString:
                if useText then
                  AField.Text := DateTimeToStr(dt)
                else
                  AField.AsString := DateTimeToStr(dt);
              else
                if useText then
                  AField.Text := FloatToStr(dt)
                else
                  AField.AsFloat := dt;
            end;
          end
          else
          begin
            case AField.DataType of
              ftFloat, ftCurrency, ftBCD, ftFMTBcd:
                if useText then
                  AField.Text := FloatToStr(d)
                else
                  AField.AsFloat := d;
              ftInteger, ftSmallint, ftWord:
                if useText then
                  AField.Text := IntToStr(Round(d))
                else
                  AField.AsInteger := Round(d);
              {$IFNDEF LCLLIB}
              ftLongWord:
                begin
                  {$IFNDEF WEBLIB}
                  if (d >= 0) and (d <= High(LongWord)) then
                  begin
                    if useText then
                      AField.Text := IntToStr(Round(d))
                    else
                      AField.AsLongWord := Round(d);
                  end
                  else
                  begin
                    if useText then
                      AField.Text := '0'
                    else
                      AField.AsLongWord := 0;
                  end;
                  {$ELSE}
                  if useText then
                    AField.Text := IntToStr(Round(d))
                  else
                    AField.AsInteger := Round(d);
                  {$ENDIF}
                end;
              {$ENDIF}
              ftLargeint:
                if useText then
                  AField.Text := IntToStr(Round(d))
                else
                  AField.AsLargeInt := Round(d);
              ftString, ftWideString:
                if useText then
                  AField.Text := FloatToStr(d)
                else
                  AField.AsString := FloatToStr(d);
              else
                if useText then
                  AField.Text := FloatToStr(d)
                else
                  AField.AsFloat := d;
            end;
          end;
        end;
      end;

      {$IFNDEF WEBLIB}
      tkInt64:
      begin
        if not TTMSFNCPersistence.IsWriteOnly(p) then
        begin
          ii := GetOrdProp(o, p);
          useText := Assigned(AField.OnSetText);

          case AField.DataType of
            ftLargeint:
              if useText then
                AField.Text := IntToStr(ii)
              else
                AField.AsLargeInt := ii;
            ftInteger, ftSmallint, ftWord, ftAutoInc:
              if useText then
                AField.Text := IntToStr(ii)
              else
                AField.AsInteger := ii;
            {$IFNDEF LCLLIB}
            ftLongWord:
              if useText then
                AField.Text := IntToStr(ii)
              else
                AField.AsLongWord := ii;
            {$ENDIF}
            ftFloat, ftCurrency:
              if useText then
                AField.Text := IntToStr(ii)
              else
                AField.AsFloat := ii;
            ftString, ftWideString:
              if useText then
                AField.Text := IntToStr(ii)
              else
                AField.AsString := IntToStr(ii);
            else
              if useText then
                AField.Text := IntToStr(ii)
              else
                AField.AsLargeInt := ii;
          end;
        end;
      end;
      {$ENDIF}

      tkSet:
      begin
        if not TTMSFNCPersistence.IsWriteOnly(p) then
        begin
          i := GetOrdProp(o, p);
          useText := Assigned(AField.OnSetText);

          case AField.DataType of
            ftInteger, ftSmallint, ftWord:
              if useText then
                AField.Text := IntToStr(i)
              else
                AField.AsInteger := i;
            {$IFNDEF LCLLIB}
            ftLongWord:
              begin
                {$IFNDEF WEBLIB}
                if useText then
                  AField.Text := IntToStr(LongWord(i))
                else
                  AField.AsLongWord := LongWord(i);
                {$ELSE}
                if useText then
                  AField.Text := IntToStr(i)
                else
                  AField.AsInteger := i;
                {$ENDIF}
              end;
            {$ENDIF}
            ftString, ftWideString:
              {$IFNDEF WEBLIB}
              begin
                s := SetToString(TTMSFNCPersistence.GetPropInfoDataTypeInfo(p), i, True);
                if useText then
                  AField.Text := s
                else
                  AField.AsString := s;
              end;
              {$ELSE}
              if useText then
                AField.Text := IntToStr(i)
              else
                AField.AsString := IntToStr(i);
              {$ENDIF}
            else
              if useText then
                AField.Text := IntToStr(i)
              else
                AField.AsInteger := i;
          end;
        end;
      end;
    end;

    DoAfterWritePropertyToField(o, Self, p, pName, k, AField);
  except
    on E: Exception do
    begin
    end;
  end;
end;

procedure TTMSFNCDataBinderItem.WriteValueToField;
begin
  if CheckDataSet and (DataSetIsEditing or DataSetIsInserting) then
  begin
    FDirty := True;
    UpdateDataLink(dlmUpdateData);
  end;
end;

procedure TTMSFNCDataBinderItem.Reset;
begin
//
end;

{$IFDEF LCLLIB}
function TTMSFNCDataBinderItem.QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} iid : tguid;out obj) : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCDataBinderItem.QueryInterface(const IID: TGUID; out Obj): HResult;
{$ENDIF}
const
  E_NOINTERFACE = HResult($80004002);
begin
  if GetInterface(IID, Obj) then Result := 0 else Result := E_NOINTERFACE;
end;

{$IFDEF LCLLIB}
function TTMSFNCDataBinderItem._AddRef: longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCDataBinderItem._AddRef: Integer;
{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._AddRef else
    Result := -1;
end;

{$IFDEF LCLLIB}
function TTMSFNCDataBinderItem._Release: longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCDataBinderItem._Release: Integer;
{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._Release else
    Result := -1;
end;

{ TTMSFNCDataBinderFieldNames }

function TTMSFNCDataBinderFieldNames.Add: TTMSFNCDataBinderFieldName;
begin
  Result := TTMSFNCDataBinderFieldName(inherited Add);
end;

constructor TTMSFNCDataBinderFieldNames.Create(AOwner: TTMSFNCDataBinderItem);
begin
  inherited Create(AOwner, GetDataBinderFieldNameClass);
  FOwner := AOwner;
end;

function TTMSFNCDataBinderFieldNames.GetDataBinderFieldNameClass: TCollectionItemClass;
begin
  Result := TTMSFNCDataBinderFieldName;
end;

function TTMSFNCDataBinderFieldNames.GetItemEx(Index: Integer): TTMSFNCDataBinderFieldName;
begin
  Result := TTMSFNCDataBinderFieldName(inherited Items[Index]);
end;

function TTMSFNCDataBinderFieldNames.Insert(index: Integer): TTMSFNCDataBinderFieldName;
begin
  Result := TTMSFNCDataBinderFieldName(inherited Insert(Index));
end;

procedure TTMSFNCDataBinderFieldNames.SetItemEx(Index: Integer; const Value: TTMSFNCDataBinderFieldName);
begin
  inherited SetItem(Index, Value);
end;

{ TTMSFNCDataBinderPropertyNames }

function TTMSFNCDataBinderPropertyNames.Add: TTMSFNCDataBinderPropertyName;
begin
  Result := TTMSFNCDataBinderPropertyName(inherited Add);
end;

constructor TTMSFNCDataBinderPropertyNames.Create(AOwner: TTMSFNCDataBinderItem);
begin
  inherited Create(AOwner, GetDataBinderPropertyNameClass);
  FOwner := AOwner;
end;

function TTMSFNCDataBinderPropertyNames.GetDataBinderPropertyNameClass: TCollectionItemClass;
begin
  Result := TTMSFNCDataBinderPropertyName;
end;

function TTMSFNCDataBinderPropertyNames.GetItemEx(Index: Integer): TTMSFNCDataBinderPropertyName;
begin
  Result := TTMSFNCDataBinderPropertyName(inherited Items[Index]);
end;

function TTMSFNCDataBinderPropertyNames.Insert(index: Integer): TTMSFNCDataBinderPropertyName;
begin
  Result := TTMSFNCDataBinderPropertyName(inherited Insert(Index));
end;

procedure TTMSFNCDataBinderPropertyNames.SetItemEx(Index: Integer; const Value: TTMSFNCDataBinderPropertyName);
begin
  inherited SetItem(Index, Value);
end;


{ TTMSFNCDataBinderItems }

function TTMSFNCDataBinderItems.Add: TTMSFNCDataBinderItem;
begin
  Result := TTMSFNCDataBinderItem(inherited Add);
end;

constructor TTMSFNCDataBinderItems.Create(AOwner: TTMSFNCDataBinder);
begin
  inherited Create(AOwner, GetDataBinderItemClass);
  FOwner := AOwner;
end;

function TTMSFNCDataBinderItems.GetDataBinderItemClass: TCollectionItemClass;
begin
  Result := TTMSFNCDataBinderItem;
end;

function TTMSFNCDataBinderItems.GetItemEx(Index: Integer): TTMSFNCDataBinderItem;
begin
  Result := TTMSFNCDataBinderItem(inherited Items[Index]);
end;

function TTMSFNCDataBinderItems.Insert(index: Integer): TTMSFNCDataBinderItem;
begin
  Result := TTMSFNCDataBinderItem(inherited Insert(Index));
end;

procedure TTMSFNCDataBinderItems.SetItemEx(Index: Integer; const Value: TTMSFNCDataBinderItem);
begin
  inherited SetItem(Index, Value);
end;

{ TTMSFNCDataBinder }

procedure TTMSFNCDataBinder.BeginUpdate;
begin
  inherited;
  Inc(FUpdateCount);
end;

class procedure TTMSFNCDataBinder.BitmapToBlobField(AField: TField; ABitmap: TTMSFNCBitmap);
{$IFNDEF WEBLIB}
var
  s: TStream;
{$ENDIF}
begin
  if not Assigned(AField) then
    Exit;

  if not Assigned(AField.DataSet) then
    Exit;

  {$IFNDEF WEBLIB}
  s := AField.DataSet.CreateBlobStream(AField, bmWrite);
  if Assigned(s) then
  begin
    try
      ABitmap.SaveToStream(s);
    finally
      s.Free;
    end;
  end;
  {$ENDIF}
end;

class procedure TTMSFNCDataBinder.BlobFieldToBitmap(AField: TField;
  ABitmap: TTMSFNCBitmap);
{$IFNDEF WEBLIB}
type
  TGraphicHeader = record
    Count: Word;                { Fixed at 1 }
    HType: Word;                { Fixed at $0100 }
    Size: Integer              { Size not including header }
  end;
var
  s: TStream;
  Size: Longint;
  GraphicHeader: TGraphicHeader;
  Header: TBytes;

  {$IFDEF CMNLIB}
  ms: TMemoryStream;
  gcc: TGraphicClass;
  p: TGraphic;
  {$ENDIF}

  sig: word;
  i: Integer;
  oletype: Integer;
  oleoffset: Integer;
  b: Byte;
{$ENDIF}
begin
  if not Assigned(AField) then
    Exit;

  if not Assigned(AField.DataSet) then
    Exit;

  {$IFDEF WEBLIB}
  ABitmap.LoadFromURL(AField.AsString);
  {$ELSE}
  s := AField.DataSet.CreateBlobStream(AField, bmRead);
  if Assigned(s) then
  begin
    try
      Size := s.Size;
      if Size >= SizeOf(TGraphicHeader) then
      begin
        SetLength(Header, SizeOf(TGraphicHeader));
        s.Read(Header, Length(Header));
        System.Move(Header[0], GraphicHeader, SizeOf(TGraphicHeader));
        if (GraphicHeader.Count <> 1) or (GraphicHeader.HType <> $0100) or
          (GraphicHeader.Size <> Size - SizeOf(GraphicHeader)) then
          s.Position := 0;
      end;

      if (s.Position = 0) and (s.Size > 2) then
      begin
        oletype := -1;
        oleoffset := 0;

        sig := 0;
        s.Read(sig, 2);
        case sig of
          $1C15:
          begin
            i := 0;
            b := 0;
            while (i < 512) do
            begin
              s.Read(b, 1);
              inc(i);
              if (b = $FF) then
              begin
                s.Read(b, 1);
                inc(i);
                if b = $D8 then
                begin
                  oletype := 1;
                  oleoffset := i;
                  break;
                end;
              end;
              if (b = $47) then
              begin
                s.Read(b, 1);
                inc(i);
                if b = $49 then
                begin
                  oletype := 2;
                  oleoffset := i;
                  break;
                end;
              end;
              if (b = ord('B')) then
              begin
                s.Read(b, 1);
                inc(i);
                if (b = ord('M')) then
                begin
                  oletype := 0;
                  oleoffset := i;
                  Break;
                end;
              end;
            end;
          end;
        end;

        if oletype in [0, 1, 2] then
          s.Seek(oleoffset, TSeekOrigin.soBeginning)
        else
          s.Position := 0;
      end;

      {$IFDEF CMNLIB}
      ms := TMemoryStream.Create;
      ms.CopyFrom(s, s.Size - s.Position);
      ms.Position := 0;

      try
        if TTMSFNCUtils.FindGraphicClass(ms.Memory^, ms.Size, gcc) then
        begin
          p := gcc.Create;
          try
            ms.Position := 0;
            p.LoadFromStream(ms);
            ABitmap.Assign(p)
          finally
            p.Free;
          end;
        end;
      finally
        ms.Free;
      end;
      {$ENDIF}
      {$IFDEF FMXLIB}
      ABitmap.LoadFromStream(s);
      {$ENDIF}
    finally
      s.Free;
    end;
  end;
  {$ENDIF}
end;

function TTMSFNCDataBinder.Connect(AObject: TObject; ADataSource: TDataSource; APropertyName: string; AFieldName: string = '';
  AHTMLTemplate: string = ''; ASubPropertyNames: TTMSFNCDataBinderStringArray = nil;
  ASubFieldNames: TTMSFNCDataBinderStringArray = nil; ASubHTMLTemplates: TTMSFNCDataBinderStringArray = nil;
  ABindType: TTMSFNCDataBinderBindType = dbbtSingleValue): TTMSFNCDataBinderItem;
var
  I: Integer;
begin
  Result := FItems.Add;
  Result.DataSource := ADataSource;
  Result.BindType := ABindType;
  Result.FieldName := AFieldName;
  Result.&Object := AObject;
  Result.PropertyName := APropertyName;
  Result.HTMLTemplate := AHTMLTemplate;

  if Assigned(ASubPropertyNames) then
  begin
    for I := 0 to Length(ASubPropertyNames) - 1 do
      Result.SubPropertyNames.Add.Value := ASubPropertyNames[I];
  end;

  if Assigned(ASubFieldNames) then
  begin
    for I := 0 to Length(ASubFieldNames) - 1 do
      Result.SubFieldNames.Add.Value := ASubFieldNames[I];
  end;

  if Assigned(ASubHTMLTemplates) then
  begin
    for I := 0 to Length(ASubHTMLTemplates) - 1 do
      Result.SubFieldNames.Add.HTMLTemplate := ASubHTMLTemplates[I];
  end;
end;

function TTMSFNCDataBinder.ConnectColumnList(AObject: TObject;
  ADataSource: TDataSource; AListPropertyName, AColumnsPropertyName,
  AColumnsSubPropertyName: string; AListSubPropertyName: string): TTMSFNCDataBinderItem;
begin
  Result := FItems.Add;
  Result.DataSource := ADataSource;
  Result.BindType := dbbtColumnList;
  Result.ColumnsPropertyName := AColumnsPropertyName;
  Result.ColumnsSubPropertyName := AColumnsSubPropertyName;
  Result.&Object := AObject;
  Result.PropertyName := AListPropertyName;
  Result.SubPropertyNames.Add.Value := AListSubPropertyName;
end;

function TTMSFNCDataBinder.ConnectGrid(AObject: TObject;
  ADatasource: TDataSource): TTMSFNCDataBinderItem;
begin
  Result := FItems.Add;
  Result.DataSource := ADataSource;
  Result.BindType := dbbtGrid;
  Result.&Object := AObject;
end;

function TTMSFNCDataBinder.ConnectList(AObject: TObject;
  ADataSource: TDataSource; APropertyName, AFieldName: string): TTMSFNCDataBinderItem;
begin
  Result := Connect(AObject, ADataSource, APropertyName, AFieldName, '', nil, nil, nil, dbbtList);
end;

function TTMSFNCDataBinder.ConnectListHTMLTemplate(AObject: TObject;
  ADataSource: TDataSource; APropertyName: string; ASubPropertyNames,
  ASubHTMLTemplates: TTMSFNCDataBinderStringArray): TTMSFNCDataBinderItem;
begin
  Result := Connect(AObject, ADataSource, APropertyName, '', '', ASubPropertyNames, nil, ASubHTMLTemplates, dbbtList);
end;

function TTMSFNCDataBinder.ConnectListHTMLTemplate(AObject: TObject;
  ADataSource: TDataSource; APropertyName,
  AHTMLTemplate: string): TTMSFNCDataBinderItem;
begin
  Result := Connect(AObject, ADataSource, APropertyName, '', AHTMLTemplate, nil, nil, nil, dbbtList);
end;

function TTMSFNCDataBinder.ConnectList(AObject: TObject;
  ADataSource: TDataSource; APropertyName: string; ASubPropertyNames,
  ASubFieldNames: TTMSFNCDataBinderStringArray): TTMSFNCDataBinderItem;
begin
  Result := Connect(AObject, ADataSource, APropertyName, '', '', ASubPropertyNames, ASubFieldNames, nil, dbbtList);
end;

function TTMSFNCDataBinder.ConnectSingle(AObject: TObject;
  ADataSource: TDataSource; APropertyName, AFieldName: string): TTMSFNCDataBinderItem;
begin
  Result := Connect(AObject, ADataSource, APropertyName, AFieldName);
end;

function TTMSFNCDataBinder.ConnectSingleHTMLTemplate(AObject: TObject;
  ADataSource: TDataSource; APropertyName,
  AHTMLTemplate: string): TTMSFNCDataBinderItem;
begin
  Result := Connect(AObject, ADataSource, APropertyName, '', AHTMLTemplate);
end;

constructor TTMSFNCDataBinder.Create(AOwner: TComponent);
begin
  inherited;
  FItems := CreateItems;
end;

constructor TTMSFNCDataBinder.Create;
begin
  Create(nil);
end;

function TTMSFNCDataBinder.CreateItems: TTMSFNCDataBinderItems;
begin
  Result := TTMSFNCDataBinderItems.Create(Self);
end;

destructor TTMSFNCDataBinder.Destroy;
begin
  FItems.Free;
  inherited;
end;

procedure TTMSFNCDataBinder.DoAfterWritePropertyToField(AObject: TObject;
  AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo;
  APropertyName: string; APropertyKind: TTypeKind; AField: TField);
begin
  if Assigned(OnAfterWritePropertyToField) then
    OnAfterWritePropertyToField(Self, AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AField);
end;

procedure TTMSFNCDataBinder.DoAfterWriteFieldToProperty(AObject: TObject;
  AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo;
  APropertyName: string; APropertyKind: TTypeKind; AField: TField);
begin
  if Assigned(OnAfterWriteFieldToProperty) then
    OnAfterWriteFieldToProperty(Self, AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AField);
end;

procedure TTMSFNCDataBinder.DoAfterWriteHTMLTemplateToProperty(AObject: TObject;
  AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo;
  APropertyName: string; APropertyKind: TTypeKind; AHTMLTemplate: string);
begin
  if Assigned(OnAfterWriteHTMLTemplateToProperty) then
    OnAfterWriteHTMLTemplateToProperty(Self, AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AHTMLTemplate);
end;

procedure TTMSFNCDataBinder.DoBeforeWriteFieldToProperty(AObject: TObject;
  AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo;
  APropertyName: string; APropertyKind: TTypeKind; AField: TField;
  var AAllow: Boolean);
begin
  if Assigned(OnBeforeWriteFieldToProperty) then
    OnBeforeWriteFieldToProperty(Self, AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AField, AAllow);
end;

procedure TTMSFNCDataBinder.DoBeforeWritePropertyToField(AObject: TObject;
  AItem: TTMSFNCDataBinderItem; APropertyInfo: TTMSFNCPropertyInfo;
  APropertyName: string; APropertyKind: TTypeKind; AField: TField;
  var AAllow: Boolean);
begin
  if Assigned(OnBeforeWritePropertyToField) then
    OnBeforeWritePropertyToField(Self, AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AField, AAllow);
end;

procedure TTMSFNCDataBinder.DoBeforeWriteHTMLTemplateToProperty(
  AObject: TObject; AItem: TTMSFNCDataBinderItem;
  APropertyInfo: TTMSFNCPropertyInfo; APropertyName: string;
  APropertyKind: TTypeKind; var AHTMLTemplate: string; var AAllow: Boolean);
begin
  if Assigned(OnBeforeWriteHTMLTemplateToProperty) then
    OnBeforeWriteHTMLTemplateToProperty(Self, AObject, AItem, APropertyInfo, APropertyName, APropertyKind, AHTMLTemplate, AAllow);
end;

procedure TTMSFNCDataBinder.EndUpdate;
begin
  inherited;
  Dec(FUpdateCount);
  if FUpdateCount = 0 then
    UpdateDataLinks;
end;

procedure TTMSFNCDataBinder.SetActive(const Value: Boolean);
var
  I: Integer;
begin
  if FActive <> Value then
  begin
    FActive := Value;
    for I := 0 to ItemCount - 1 do
      Items[I].FActive := FActive;

    UpdateDataLinks;
  end;
end;

procedure TTMSFNCDataBinder.SetDataSource(const Value: TDataSource);
var
  I: Integer;
begin
  if FDataSource <> Value then
  begin
    FDataSource := Value;
    if Assigned(FDataSource) then
    begin
      for I := 0 to ItemCount - 1 do
      begin
        if Items[I].DataSource = nil then
          Items[I].DataSource := FDataSource;
      end;
    end;
  end;
end;

procedure TTMSFNCDataBinder.SetItems(const Value: TTMSFNCDataBinderItems);
begin
  FItems.Assign(Value);
end;

procedure TTMSFNCDataBinder.StartEditor(const AObject: TObject = nil);
var
  e: TTMSFNCDataBindingEditor;
begin
  e := TTMSFNCDataBindingEditor.Create(Self);
  try
    e.DataBinder := Self;
    e.&Object := AObject;
    e.Execute
    {$IFDEF WEBLIB}
    (procedure(AResult: TModalResult)
    begin
      e.Free;
    end)
    {$ENDIF}
    ;
  finally
    {$IFNDEF WEBLIB}
    e.Free;
    {$ENDIF}
  end;
end;

procedure TTMSFNCDataBinder.UpdateDataLinks;
var
  I: Integer;
begin
  for I := 0 to FItems.Count - 1 do
    FItems[I].UpdateDataLink(dlmActiveChanged);
end;

function TTMSFNCDataBinder.GetDataSource: TDataSource;
begin
  Result := FDataSource;
end;

procedure TTMSFNCDataBinder.GetDataSources(AStrings: TStrings);
var
  f: TComponent;
  i: integer;
  K: Integer;
begin
  f := TTMSFNCUtils.GetOwnerForm(Self);
  if Assigned(f) then
  begin
    for i := 0 to f.ComponentCount - 1 do
    begin
      if f.Components[i] is TFrame then
      begin
        for K := 0 to (f.Components[i] as TFrame).ComponentCount - 1 do
        begin
          if ((f.Components[i] as TFrame).Components[K] is TDataSource) then
          begin
            AStrings.AddObject((f.Components[i] as TFrame).Components[K].Name, (f.Components[i] as TFrame).Components[K]);
          end;
        end;
      end
      else
      begin
        if (f.Components[i] is TDataSource) then
        begin
          AStrings.AddObject(f.Components[i].Name, f.Components[i]);
        end;
      end;
    end;
  end;
end;

function TTMSFNCDataBinder.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfnccore/components/ttmsfncdatabinding/';
end;

function TTMSFNCDataBinder.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCDataBinder.GetItemByName(AName: string): TTMSFNCDataBinderItem;
var
  I: Integer;
begin
  Result := nil;
  for I := 0 to Items.Count - 1 do
  begin
    if (Items[I].Name <> '') and (Items[I].Name = AName) then
    begin
      Result := Items[I];
      Break;
    end;
  end;
end;

function TTMSFNCDataBinder.GetItemByObject(
  AObject: TObject; APropertyName: string): TTMSFNCDataBinderItem;
var
  I: Integer;
begin
  Result := nil;
  for I := 0 to Items.Count - 1 do
  begin
    if (Items[I].&Object = AObject) and ((Items[I].PropertyName = APropertyName) or (APropertyName = '')) then
    begin
      Result := Items[I];
      Break;
    end;
  end;
end;

function TTMSFNCDataBinder.GetItems: TTMSFNCDataBinderItems;
begin
  Result := FItems;
end;

class function TTMSFNCDataBinder.GetPropertyList(AObject: TObject): TTMSFNCDataBinderPropertyList;
begin
  Result := GetPropertyList(AObject, False);
end;

class function TTMSFNCDataBinder.GetPropertyList(AObject: TObject; IncludePublic: Boolean): TTMSFNCDataBinderPropertyList;
var
  {$IFNDEF WEBLIB}
  ci: Pointer;
  c: Integer;
  pl: PPropList;
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  rttiContext: TRttiContext;
  rttiType: TRttiType;
  rttiProps: TArray<TRttiProperty>;
  rttiProp: TRttiProperty;
  {$ENDIF}
  {$IFDEF WEBLIB}
  ci: TTypeInfoClass;
  p: TTMSFNCPropertyInfo;
  a: TTypeMemberPropertyDynArray;
  {$ENDIF}
  I: Integer;
begin
  SetLength(Result, 0);
  if not Assigned(AObject) then
    Exit;

  {$IFNDEF WEBLIB}
  ci := AObject.ClassInfo;
  c := GetPropList(ci, tkProperties, nil);
  if c > 0 then
  begin
    GetMem(pl, c * SizeOf(TTMSFNCPropertyInfo));
    try
      GetPropList(ci, tkProperties, pl);
      for I := 0 to c - 1 do
      begin
        SetLength(Result, Length(Result) + 1);
        Result[Length(Result) - 1] := pl^[i];
      end;
    finally
      FreeMem(pl);
    end;
  end;

  {$IFNDEF LCLLIB}
  if IncludePublic then
  begin
    try
      rttiContext := TRttiContext.Create;
      try
        rttiType := rttiContext.GetType(AObject.ClassType);
        if Assigned(rttiType) then
        begin
          rttiProps := rttiType.GetProperties;
          for rttiProp in rttiProps do
          begin
            if (rttiProp.Visibility = mvPublic) and (rttiProp.PropertyType.TypeKind <> tkMethod) then
            begin
              SetLength(Result, Length(Result) + 1);
              Result[Length(Result) - 1] := nil;
            end;
          end;
        end;
      finally
        rttiContext.Free;
      end;
    except
    end;
  end;
  {$ENDIF}
  {$ENDIF}

  {$IFDEF WEBLIB}
  ci := TypeInfo(AObject);
  a := GetPropList(ci, tkProperties);
  for I := 0 to Length(a) - 1 do
  begin
    SetLength(Result, Length(Result) + 1);
    Result[Length(Result) - 1] := a[i];
  end;
  {$ENDIF}
end;

{$IFNDEF WEBLIB}
class function TTMSFNCDataBinder.GetPropertyNames(AObject: TObject; IncludePublic: Boolean = True): TTMSFNCDataBinderStringArray;
var
  ci: Pointer;
  c: Integer;
  pl: PPropList;
  {$IFNDEF LCLLIB}
  rttiContext: TRttiContext;
  rttiType: TRttiType;
  rttiProps: TArray<TRttiProperty>;
  rttiProp: TRttiProperty;
  {$ENDIF}
  I: Integer;
  nameList: TStringList;
begin
  nameList := TStringList.Create;
  try
    nameList.Sorted := True;
    nameList.Duplicates := dupIgnore;

    if Assigned(AObject) then
    begin
      ci := AObject.ClassInfo;
      c := GetPropList(ci, tkProperties, nil);
      if c > 0 then
      begin
        GetMem(pl, c * SizeOf(PPropInfo));
        try
          GetPropList(ci, tkProperties, pl);
          for I := 0 to c - 1 do
          begin
            {$IFNDEF LCLLIB}
            {$HINTS OFF}
            {$IF COMPILERVERSION > 33}
            if Assigned(pl^[i]) then
              nameList.Add(string(pl^[i]^.Name));
            {$IFEND}
            {$HINTS ON}
            {$ENDIF}
          end;
        finally
          FreeMem(pl);
        end;
      end;

      {$IFNDEF LCLLIB}
      if IncludePublic then
      begin
        try
          rttiContext := TRttiContext.Create;
          try
            rttiType := rttiContext.GetType(AObject.ClassType);
            if Assigned(rttiType) then
            begin
              rttiProps := rttiType.GetProperties;
              for rttiProp in rttiProps do
              begin
                if (rttiProp.PropertyType.TypeKind <> tkMethod) and (rttiProp.Visibility in [mvPublic, mvPublished]) then
                  nameList.Add(rttiProp.Name);
              end;
            end;
          finally
            rttiContext.Free;
          end;
        except
        end;
      end;
      {$ENDIF}
    end;

    SetLength(Result, nameList.Count);
    for I := 0 to nameList.Count - 1 do
      Result[I] := nameList[I];

  finally
    nameList.Free;
  end;
end;
{$ENDIF}

{$IFDEF WEBLIB}
class function TTMSFNCDataBinder.GetPropertyNames(AObject: TObject; IncludePublic: Boolean = True): TTMSFNCDataBinderStringArray;
var
  ci: TTypeInfoClass;
  a: TTypeMemberPropertyDynArray;
  I: Integer;
begin
  SetLength(Result, 0);
  if Assigned(AObject) then
  begin
    ci := TypeInfo(AObject);
    a := GetPropList(ci, tkProperties);
    SetLength(Result, Length(a));
    for I := 0 to Length(a) - 1 do
      Result[I] := TTMSFNCPersistence.GetPropInfoName(a[I]);
  end;
end;
{$ENDIF}

function TTMSFNCDataBinder.GetVersion: string;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

function TTMSFNCDataBinder.HasEditLinkMonitor(AObject: TObject): Boolean;
var
  I: Integer;
begin
  Result := False;
  for I := 0 to ItemCount - 1 do
  begin
    if (Items[I].&Object = AObject) and Items[I].HasEditLinkMonitor then
    begin
      Result := True;
      Break;
    end;
  end;
end;

function TTMSFNCDataBinder.HasControlValueMonitor(AObject: TObject): Boolean;
var
  I: Integer;
begin
  Result := False;
  for I := 0 to ItemCount - 1 do
  begin
    if (Items[I].&Object = AObject) and Items[I].HasControlValueMonitor then
    begin
      Result := True;
      Break;
    end;
  end;
end;

function TTMSFNCDataBinder.IsConnected(AObject: TObject): Boolean;
var
  I: Integer;
begin
  Result := False;
  for I := 0 to ItemCount - 1 do
  begin
    if Items[I].&Object = AObject then
    begin
      Result := True;
      Break;
    end;
  end;
end;

function TTMSFNCDataBinder.ItemCount: Integer;
begin
  Result := Items.Count;
end;

procedure TTMSFNCDataBinder.Notification(AComponent: TComponent;
  AOperation: TOperation);
var
  i: Integer;
begin
  if (AOperation = opRemove) and not (csDestroying in ComponentState) then
  begin
    if FDataSource = AComponent then
      FDataSource := nil;

    i := FItems.Count - 1;
    while (i >= 0) do
    begin
      if FItems[i].DataSource = AComponent then
        FItems[i].DataSource := nil;

      if FItems[I].&Object = AComponent then
        FItems[I].&Object := nil;
      Dec(i);
    end;
  end;
  inherited;
end;

procedure TTMSFNCDataBinder.NotifyEdit;
var
  I: Integer;
begin
  for I := 0 to ItemCount - 1 do
    Items[I].NotifyEdit;
end;

procedure TTMSFNCDataBinder.NotifyPost;
var
  I: Integer;
begin
  for I := 0 to ItemCount - 1 do
    Items[I].NotifyPost;
end;

procedure TTMSFNCDataBinder.NotifySetActiveRecord;
var
  I: Integer;
begin
  for I := 0 to ItemCount - 1 do
    Items[I].NotifySetActiveRecord;
end;

procedure TTMSFNCDataBinder.NotifyUpdate;
var
  I: Integer;
begin
  for I := 0 to ItemCount - 1 do
    Items[I].NotifyUpdate;
end;

procedure TTMSFNCDataBinder.NotifyValueChanged;
var
  I: Integer;
begin
  for I := 0 to ItemCount - 1 do
    Items[I].NotifyValueChanged;
end;

procedure TTMSFNCDataBinder.RegisterRuntimeClasses;
begin
  RegisterClass(TTMSFNCDataBinder);
end;

{ TTMSFNCDataBinderDataLink }

procedure TTMSFNCDataBinderDataLink.ActiveChanged;
begin
  FDataBinderItem.UpdateDataLink(dlmActiveChanged);
end;

constructor TTMSFNCDataBinderDataLink.Create(ADataBinderItem: TTMSFNCDataBinderItem);
begin
  FDataBinderItem := ADataBinderItem;
  VisualControl := True;
end;

procedure TTMSFNCDataBinderDataLink.DataSetChanged;
begin
  FDataBinderItem.UpdateDataLink(dlmDataSetChanged);
end;

procedure TTMSFNCDataBinderDataLink.DataSetScrolled(Distance: Integer);
begin
  FDataBinderItem.UpdateDataLink(dlmDataSetScrolled, Distance);
end;

destructor TTMSFNCDataBinderDataLink.Destroy;
begin

  inherited;
end;

procedure TTMSFNCDataBinderDataLink.RecordChanged(Field: TField);
begin
  if Assigned(Field) then
    FDataBinderItem.UpdateDataLink(dlmRecordChanged, -1, Field);
end;

procedure TTMSFNCDataBinderDataLink.UpdateData;
begin
  FDataBinderItem.UpdateDataLink(dlmUpdateData);
end;

{ TTMSFNCDataBinderPropertyName }

procedure TTMSFNCDataBinderPropertyName.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataBinderPropertyName then
  begin
    FValue := (Source as TTMSFNCDataBinderPropertyName).Value;
  end;
end;

constructor TTMSFNCDataBinderPropertyName.Create(ACollection: TCollection);
begin
  inherited;
  FDataBinderItem := (Collection as TTMSFNCDataBinderPropertyNames).FOwner;
end;

destructor TTMSFNCDataBinderPropertyName.Destroy;
begin

  inherited;
end;

procedure TTMSFNCDataBinderPropertyName.SetValue(const Value: string);
begin
  if FValue <> Value then
  begin
    FValue := Value;
    if Assigned(FDataBinderItem) then
      FDataBinderItem.UpdateDataLink(dlmActiveChanged);
  end;
end;


{ TTMSFNCDataBinderFieldName }

procedure TTMSFNCDataBinderFieldName.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataBinderFieldName then
  begin
    FValue := (Source as TTMSFNCDataBinderFieldName).Value;
    FHTMLTemplate := (Source as TTMSFNCDataBinderFieldName).HTMLTemplate;
  end;
end;

constructor TTMSFNCDataBinderFieldName.Create(ACollection: TCollection);
begin
  inherited;
  FDataBinderItem := (Collection as TTMSFNCDataBinderFieldNames).FOwner;
end;

destructor TTMSFNCDataBinderFieldName.Destroy;
begin

  inherited;
end;

procedure TTMSFNCDataBinderFieldName.SetHTMLTemplate(const Value: string);
begin
  if FHTMLTemplate <> Value then
  begin
    FHTMLTemplate := Value;
    if Assigned(FDataBinderItem) then
      FDataBinderItem.UpdateDataLink(dlmActiveChanged);
  end;
end;

procedure TTMSFNCDataBinderFieldName.SetValue(const Value: string);
begin
  if FValue <> Value then
  begin
    FValue := Value;
    if Assigned(FDataBinderItem) then
      FDataBinderItem.UpdateDataLink(dlmActiveChanged);
  end;
end;

{ TTMSFNCDataBinderNotificationManager }

function TTMSFNCDataBinderNotificationManager.HasObject(
  AObject: TObject): Boolean;
var
  {$IFDEF WEBLIB}
  I: Integer;
  {$ENDIF}
  ifn: ITMSFNCDataBinderNotification;
begin
  Result := False;
  {$IFDEF WEBLIB}
  for I := 0 to Count - 1 do
  begin
    ifn := ITMSFNCDataBinderNotification(Self[I]);
  {$ELSE}
  for ifn in Self do
  begin
  {$ENDIF}
    if ifn.&Object = AObject then
    begin
      Result := True;
      Break;
    end;
  end;
end;

procedure TTMSFNCDataBinderNotificationManager.Notify(AObject: TObject; AType: TTMSFNCDataBinderNotificationType);
var
  {$IFDEF WEBLIB}
  I: Integer;
  {$ENDIF}
  ifn: ITMSFNCDataBinderNotification;
begin
  {$IFDEF WEBLIB}
  for I := 0 to Count - 1 do
  begin
    ifn := ITMSFNCDataBinderNotification(Self[I]);
  {$ELSE}
  for ifn in Self do
  begin
  {$ENDIF}
    if ifn.&Object = AObject then
      ifn.Notify(AType);
  end;
end;

{$IFDEF LCLLIB}
function TTMSFNCDataBinderNotificationManager.QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} iid : tguid;out obj) : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCDataBinderNotificationManager.QueryInterface(const IID: TGUID; out Obj): HResult;
{$ENDIF}
const
  E_NOINTERFACE = HResult($80004002);
begin
  if GetInterface(IID, Obj) then Result := 0 else Result := E_NOINTERFACE;
end;

{$IFDEF LCLLIB}
function TTMSFNCDataBinderNotificationManager._AddRef: longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCDataBinderNotificationManager._AddRef: Integer;
{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._AddRef else
    Result := -1;
end;

{$IFDEF LCLLIB}
function TTMSFNCDataBinderNotificationManager._Release: longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCDataBinderNotificationManager._Release: Integer;
{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._Release else
    Result := -1;
end;

{$IFDEF SUPPORTSBINDING}

{ TTMSFNCDataBinderEditLinkObserver }

destructor TTMSFNCDataBinderEditLinkObserver.Destroy;
begin
  FBinderItem := nil;
  inherited;
end;

constructor TTMSFNCDataBinderEditLinkObserver.Create(ABinderItem: TTMSFNCDataBinderItem);
begin
  inherited Create(nil);
  FBinderItem := ABinderItem;
end;

function TTMSFNCDataBinderEditLinkObserver.Edit: Boolean;
begin
  Result := False;
  if not Assigned(FBinderItem) then
    Exit;

  if FBinderItem.FUpdating or FGlobalUpdating then
    Result := True
  else
  begin
    if not FBinderItem.GetCanModify then
      Exit(False);
    FBinderItem.BeginUpdate;
    try
      FBinderItem.DataSetEdit;
      Result := FBinderItem.DataSetIsEditing;
    finally
      FBinderItem.EndUpdate;
    end;
  end;
end;

function TTMSFNCDataBinderEditLinkObserver.GetFormatLink: IEditFormatLink;
begin
  Result := nil;
//  Result := FBindLink.GetFormatLink;
end;

function TTMSFNCDataBinderEditLinkObserver.GetIsEditing: Boolean;
begin
  Result := False;
  if Assigned(FBinderItem) then
    Result := FBinderItem.DataSetIsEditing;
end;

function TTMSFNCDataBinderEditLinkObserver.GetIsReadOnly: Boolean;
begin
  Result := False;
  if Assigned(FBinderItem) then
    Result := not FBinderItem.GetCanModify;
end;

function TTMSFNCDataBinderEditLinkObserver.GetTrack: Boolean;
begin
  Result := FTrack;
end;

function TTMSFNCDataBinderEditLinkObserver.IsModified: Boolean;
begin
  Result := FModified;
end;

function TTMSFNCDataBinderEditLinkObserver.IsRequired: Boolean;
begin
  Result := False;
  if Assigned(FBinderItem) then
    Result := FBinderItem.IsRequired;
end;

function TTMSFNCDataBinderEditLinkObserver.IsValidChar(AKey: Char): Boolean;
begin
  Result := False;
  if Assigned(FBinderItem) then
    Result := FBinderItem.IsValidChar(AKey);
end;

procedure TTMSFNCDataBinderEditLinkObserver.Modified;
begin
  if Assigned(FBinderItem) then
  begin
    if not (FBinderItem.FUpdating or FGlobalUpdating) then
    begin
      FModified := True;
      FBinderItem.Modified;
    end;
  end;
end;

procedure TTMSFNCDataBinderEditLinkObserver.Reset;
begin
  if Assigned(FBinderItem) then
    FBinderItem.Reset;
end;

procedure TTMSFNCDataBinderEditLinkObserver.SetIsReadOnly(Value: Boolean);
begin
  if Assigned(FBinderItem) then
    FBinderItem.SetIsReadOnly(Value);
end;

procedure TTMSFNCDataBinderEditLinkObserver.SetTrack(AValue: Boolean);
begin
  FTrack := AValue;
end;

procedure TTMSFNCDataBinderEditLinkObserver.Update;
begin
  if not Assigned(FBinderItem) then
    Exit;

  if IsModified and (not (FBinderItem.FUpdating or FGlobalUpdating)) then
  begin
    FBinderItem.WriteValueToField;
  end;
end;

procedure TTMSFNCDataBinderEditLinkObserver.BeginUpdate;
begin
  if Assigned(FBinderItem) then
    FBinderItem.BeginUpdate;
end;

procedure TTMSFNCDataBinderEditLinkObserver.EndUpdate;
begin
  if Assigned(FBinderItem) then
    FBinderItem.EndUpdate;
end;

function TTMSFNCDataBinderEditLinkObserver.GetUpdating: Boolean;
begin
  Result := False;
  if Assigned(FBinderItem) then
    Result := FBinderItem.FUpdating or FGlobalUpdating;
end;

{ TTMSFNCDataBinderControlValueObserver }

destructor TTMSFNCDataBinderControlValueObserver.Destroy;
begin
  FBinderItem := nil;
  inherited;
end;

constructor TTMSFNCDataBinderControlValueObserver.Create(ABinderItem: TTMSFNCDataBinderItem);
begin
  inherited Create(nil);
  FBinderItem := ABinderItem;
end;

procedure TTMSFNCDataBinderControlValueObserver.ValueUpdate;
begin
  if FModified then
  begin
    FModified := False;
    if Assigned(FBinderItem) then
    begin
      FBinderItem.BeginUpdate;
      try
        FBinderItem.DataSetEdit;
      finally
        FBinderItem.EndUpdate;
      end;

      if FBinderItem.DataSetIsEditing then
        FBinderItem.WriteValueToField;
    end;
  end;
end;

procedure TTMSFNCDataBinderControlValueObserver.ValueModified;
begin
  FModified := True;
end;

function TTMSFNCDataBinderControlValueObserver.GetTrack: Boolean;
begin
  Result := FTrack;
end;

procedure TTMSFNCDataBinderControlValueObserver.SetTrack(AValue: Boolean);
begin
  FTrack := AValue;
end;
{$ENDIF}

{ TTMSFNCDataBinderControlValueMonitor }

constructor TTMSFNCDataBinderControlValueMonitor.Create(ABinderItem: TTMSFNCDataBinderItem);
begin
  inherited Create;
  FActive := False;
  FBinderItem := ABinderItem;
end;

destructor TTMSFNCDataBinderControlValueMonitor.Destroy;
begin
  StopMonitoring;
  inherited;
end;

procedure TTMSFNCDataBinderControlValueMonitor.StartMonitoring;
{$IFDEF SUPPORTSBINDING}
var
  ObserverIntf: IInterface;
  c: TComponent;
{$ENDIF}
begin
  {$IFDEF SUPPORTSBINDING}
  c := nil;
  if Assigned(FBinderItem) then
    c := FBinderItem.GetComponent;

  if not FActive and Assigned(c) then
  begin
    FObserver := TTMSFNCDataBinderControlValueObserver.Create(FBinderItem);
    ObserverIntf := FObserver as IInterface;

    if c.Observers.CanObserve(TObserverMapping.ControlValueID) then
    begin
      try
        c.Observers.AddObserver(TObserverMapping.ControlValueID, ObserverIntf);
        FActive := True;
      except
        on E: Exception do
        begin
          FObserver := nil;
        end;
      end;
    end
    else
    begin
      FObserver := nil;
    end;
  end;
  {$ENDIF}
end;

procedure TTMSFNCDataBinderControlValueMonitor.StopMonitoring;
{$IFDEF SUPPORTSBINDING}
var
  ObserverIntf: IInterface;
  c: TComponent;
{$ENDIF}
begin
  {$IFDEF SUPPORTSBINDING}
  c := nil;
  if Assigned(FBinderItem) then
    c := FBinderItem.GetComponent;

  if FActive and Assigned(c) and Assigned(FObserver) and not (csDestroying in c.componentstate) then
  begin
    try
      ObserverIntf := FObserver as IInterface;
      c.Observers.RemoveObserver(TObserverMapping.ControlValueID, ObserverIntf);
    finally
      FObserver := nil;
      FActive := False;
    end;
  end;
  {$ENDIF}
end;

{ TTMSFNCDataBinderEditLinkMonitor }

constructor TTMSFNCDataBinderEditLinkMonitor.Create(ABinderItem: TTMSFNCDataBinderItem);
begin
  inherited Create;
  FActive := False;
  FBinderItem := ABinderItem;
end;

destructor TTMSFNCDataBinderEditLinkMonitor.Destroy;
begin
  StopMonitoring;
  inherited;
end;

procedure TTMSFNCDataBinderEditLinkMonitor.StartMonitoring;
{$IFDEF SUPPORTSBINDING}
var
  ObserverIntf: IInterface;
  c: TComponent;
{$ENDIF}
begin
  {$IFDEF SUPPORTSBINDING}
  c := nil;
  if Assigned(FBinderItem) then
    c := FBinderItem.GetComponent;

  if not FActive and Assigned(c) then
  begin
    FObserver := TTMSFNCDataBinderEditLinkObserver.Create(FBinderItem);
    ObserverIntf := FObserver as IInterface;

    if c.Observers.CanObserve(TObserverMapping.EditLinkID) then
    begin
      try
        c.Observers.AddObserver(TObserverMapping.EditLinkID, ObserverIntf);
        FActive := True;
      except
        on E: Exception do
        begin
          FObserver := nil;
        end;
      end;
    end
    else
    begin
      FObserver := nil;
    end;
  end;
  {$ENDIF}
end;

procedure TTMSFNCDataBinderEditLinkMonitor.StopMonitoring;
{$IFDEF SUPPORTSBINDING}
var
  ObserverIntf: IInterface;
  c: TComponent;
{$ENDIF}
begin
  {$IFDEF SUPPORTSBINDING}
  c := nil;
  if Assigned(FBinderItem) then
    c := FBinderItem.GetComponent;

  if FActive and Assigned(c) and Assigned(FObserver) and not (csDestroying in c.componentstate) then
  begin
    try
      ObserverIntf := FObserver as IInterface;
      c.Observers.RemoveObserver(TObserverMapping.EditLinkID, ObserverIntf);
    finally
      FObserver := nil;
      FActive := False;
    end;
  end;
  {$ENDIF}
end;

initialization
begin
  if not Assigned(FManager) then
    FManager := TTMSFNCDataBinderNotificationManager.Create
end;

{$IFNDEF WEBLIB}
finalization
begin
  FreeAndNil(FManager);
end;
{$ENDIF}

end.
